/* eslint-disable @typescript-eslint/member-ordering */
/* eslint-disable @typescript-eslint/naming-convention */
import {
  Component, OnInit, ElementRef, ViewChild, OnDestroy, isDevMode, TemplateRef, ViewChildren, Renderer2, AfterViewInit, ChangeDetectorRef,
  HostListener
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ImageFile } from '../models/imageFile';
import { WebApiService, StarbaseLoginService, IUserTokenModel } from 'starbase-login';
import { ImageService } from '../services/image.service';
import { StarbaseNotificationService, StarbaseNotificationTypes, StarbaseNotificationSentiment } from 'starbase-notification';
import { MONTHS, AlphaSortArrayByProperty, checkForDuplicateDataItems, isStringUrl, createAnchorFromLink, titleCaseString, FilterParams, ContactModel } from 'starbase-launcher';
import { GalleryHistoryService } from '../services/gallery-history.service';
import { FormControl, NgForm } from '@angular/forms';
import { StarbaseModalDialogService, StarbaseModalOptions, StarbaseModalButton, StarbaseModalTypes } from 'starbase-modal-dialog';
import { StarbaseModalOverlayService } from 'modal-overlay';
import { Subscription, of, Observable, forkJoin, Subject, merge } from 'rxjs';
import { LookupDataService } from '../services/lookup-data.service';
import { debounceTime, distinctUntilChanged, switchMap, catchError, map, tap, defaultIfEmpty, filter, share, finalize, timeout } from 'rxjs/operators';
import { Army } from '../models/army';
import { State } from '../models/state';
import { LU_Keyword, KeywordLinking } from '../models/keyword';
import { IRowModel, IColumnModel, RowModel, StarbaseTableEditorComponent, ColumnModel, Notifier } from 'table-editor';
import { UnitLinking, UnitArmies } from '../models/unitLinking';
import { ImageDate } from '../models/imageDate';
import { TypeaheadResults } from '../models/typeaheadResults';
import { GalleryTypeService } from '../services/gallery-type.service';
import { PrimaryWeapon } from '../models/primaryWeapon';
import { SecondaryWeapon } from '../models/secondaryWeapon';
import { Weapon } from '../models/weapon';
import { WeaponLinking } from '../models/weaponLinking';
import { QMManual } from '../models/qmmanual';
import { Rank } from '../models/rank';
import { RankCategory } from '../models/rankCategory';
import { ImageIndividual } from '../models/imageIndividual';
import { Regiment } from '../models/regiment';
import { BranchOfService } from '../models/branchOfService';
import { LUArmy } from '../models/luArmy';
import { WriteOrdinalSuffixOfNumber } from 'starbase-launcher';
import { IEditCheck } from 'starbase-launcher';
import { LUSource } from '../models/luSource';
import { RelatedSetLinkingModel } from '../models/relatedSetLinkingModel';
import { AppInsightsService } from '../app-insights.service';
import { ImageTypes, ImageType } from '../models/imageType';
import { BoundImageSet } from '../models/boundImageSet';
import { ActionCompleteEventArgs, NodeSelection, RichTextEditorComponent } from '@syncfusion/ej2-angular-richtexteditor';
import { libraryViewModes } from '../libraryViewModes';
import { CallNumberModel } from '../models/callNumberModel';
import Panzoom from '@panzoom/panzoom';
import { AppComponent, CONTACTUS_SUGGESTION } from '../app.component';
import { QMManualLink } from '../models/qmmanuallink';
import { NgbTypeahead, NgbTypeaheadSelectItemEvent } from '@ng-bootstrap/ng-bootstrap';
import { EmboldenPipe } from '../pipes/embolden.pipe';
import { DomSanitizer, Title } from '@angular/platform-browser';
import { RecentThumbnailsComponent } from '../recent-thumbnails/recent-thumbnails.component';
import { StarbaseComponentMessageService } from '../services/starbase-component-message.service';
import { AppGlobalsService } from '../app-globals.service';
import { ImageCarouselComponent } from '../image-carousel/image-carousel.component';
import { WebSocketService } from '../services/web-socket.service';
import { BattleSelect, Battle } from '../models/battle';
import { BattleLink } from '../models/battleLink';
import { KeywordDataService } from '../services/keyword-data.service';
import { TransactionLogService } from '../services/transactionlog-data.service';
import { galleryAnimationFade, galleryAnimationStagger } from '../animations';
import { IndividualsDisplayComponent } from '../individuals-display/individuals-display.component';
import { PlatformLocation } from '@angular/common';
import { ContactRequestService } from '../services/contact-request.service';
import { ContactRequestModel } from 'contact-us-form/lib/contact-requestModel';
import { CRAWLER_AGENTS, robots } from '../crawlers';
import { RelatedImageSetViewDataModel } from '../models/relatedImageSetViewDataModel';
import { ImageCarouselHolderComponent } from '../image-carousel-holder/image-carousel-holder.component';
import { BreakpointService, BreakpointState } from '../breakpoint.service';
import { RelatedSetModel } from '../models/relatedSetModel';
/** Default time for typeahead RxJS debounce calls. */
const DEFAULT_DEBOUNCE = 300; // ms

@Component({
  selector: 'app-single-image-view',
  templateUrl: './single-image-view.component.html',
  styleUrls: ['./single-image-view.component.css'],
  animations: [galleryAnimationFade, galleryAnimationStagger]
})

/** Primary view for one image record of most image types in RA system. */
export class SingleImageViewComponent implements OnInit, OnDestroy, AfterViewInit, IEditCheck {
  /* ....PanZoom Utility Element References Section.... */
  @ViewChild('panZoomDiv') panZoomDiv: ElementRef; // main wrapper element  for the panzoom utility
  @ViewChild('zoomOutBtn') zoomOutBtn: ElementRef<HTMLElement>; // button for zooming out
  @ViewChild('zoomInBtn') zoomInBtn: ElementRef; // button for zooming in
  @ViewChild('zoomRange') zoomRange: ElementRef; // range (slider) for changing zoom level
  @ViewChild('zoomResetBtn') zoomResetBtn: ElementRef; // button for reset zoom to default
  /* ....End PanZoom Utility Element Refs Section.... */

  @ViewChild('delConfirmTxt') delConfirmTxt: ElementRef; // text input for deletion confirmation modal
  @ViewChild('deleteConfirmModal', { static: true }) deleteConfirmModal: TemplateRef<any>;
  @ViewChild('keystrokeHelpModal', { static: true }) keystrokeHelpModal: TemplateRef<any>;
   // TODO: ^^ to be ported to the Starbase help system, once it's done

  @ViewChild('rotateThumbnail', { static: true }) rotateThumbnailModal: TemplateRef<any>;
  @ViewChild('recentThumbs') recentThumbs: RecentThumbnailsComponent;
  @ViewChild('imageCarouselHolder') imageCarouselHolder: ImageCarouselHolderComponent;
  @ViewChild('imageCarousel') boundImages: ImageCarouselComponent;
  
  //ledger carousel
  @ViewChild('ledgerCarousel') ledgerCarousel: ImageCarouselComponent;

  @ViewChild('imageForm') imageForm: NgForm; // the input form on the template for all fields
  /** Reference to all of the Starbase Table Editor components in the view */
  @ViewChildren(StarbaseTableEditorComponent) tableEditors: StarbaseTableEditorComponent[];
  @ViewChild('unitTable') unitTable: StarbaseTableEditorComponent;
  @ViewChild('keywordSearcher') keywordsInputEl: NgbTypeahead;
  @ViewChild('singleImageViewWrapper', { static: false }) singleImageViewWrapper: ElementRef;
  @ViewChild('unitTable') unitsTable: StarbaseTableEditorComponent;
  @ViewChild('weaponsTable') weaponsTable: StarbaseTableEditorComponent;
  @ViewChild('individualDisplayComponent') IndividualDisplay: IndividualsDisplayComponent;

  @ViewChild('toolsRTE') rtfComp: RichTextEditorComponent;

  imageData: ImageFile; // main object containing the image data for this view

  /** The name field to display over the image. Changes when moving between bound images in a set. */
  displayName: string;

  battleClick$ = new Subject<string>();
  battleFocus$ = new Subject<string>();
  regionClick$ = new Subject<string>();
  regionFocus$ = new Subject<string>();
  locationClick$ = new Subject<string>();
  locationFocus$ = new Subject<string>();
  keywordClick$ = new Subject<string>();
  keywordFocus$ = new Subject<string>();

  ignoreTypeaheadSuggestion = false;
  isGeneratingThumbnail = false;

  librarySearchText: string; // the string, if any, the user searched by on the gallery.
  searchHighlightStyle = 'style=\'background-color: rgba(250, 250, 50, 0.6);\''; // the yellow color to apply to found search match text
  originalTranscriptionText: string; //the original transcription without Highlighted text

  private _subscription;
  private _imgRepairSubscription;
  isHandset = false;

  /** Main toggle to determine if the view is in EditMode, which will show the edit controls. */
  public editMode = false;
  /** If true, EditMode persists when Save is pressed and when Next/Prev button are pressed, save occurs automatically. */
  public stayInEditMode = false;
  /** The indicator for when entire data set load has completed. */
  public loaded = false;
  /** Used to hide/show admin-only features and controls. Should typically be set by the Login Module. */
  public isAdmin: boolean;
  /** Used to Identify a Separate display for Crawlers to allow Indexing. */
  public isCrawler = false;
  /** Currently Logged In user */
  public loggedInUser: IUserTokenModel = null;
  /** Indicates whether the panZoom utility is active or not. */
  public zoomMode = false;
  public currentZoomLevel = 0.9;
  
  /** Image transformation properties */
  public rotationAngle = 0; // Rotation angle in degrees
  public isFlippedHorizontally = false; // Horizontal mirror/flip
  public isFlippedVertically = false; // Vertical mirror/flip
  
  /** Used to display something on screen when loading fails. */
  public errorMessage = '';
  /** Flag for when record is loaded from Quarter Master screen. */
  public loadedFromQM = false;
  /** Id of the QM record loaded from. */
  public qmID: number;
  /** Whether the "Showing X of Y" text should read the filters length (false) */
  simpleIndex = false;

  /* ...New Entity Mode bool section... */
  public newArmyMode = false;
  public newWeaponMode = false;
  public newUnitMode = false;
  public newRegimentMode = false;
  public newBranchMode = false;
  public newWeaponCatMode = false;
  public newRankMode = false;
  public newRankCatMode = false;
  public newSourceMode = false;
  /* ... End new entity mode bool section... */

  /** Imports the ImageTypes enum. */
  // eslint-disable-next-line @typescript-eslint/naming-convention
  ImageTypes = ImageTypes; // re-access these vals on the template

  isStringUrl = isStringUrl;
  createAnchorFromLinkFn = createAnchorFromLink;
  callNoIsUrl = false;

  /** Imports the LibraryViewModes enum. */
  libViewModes = libraryViewModes;

  /** When true, the Unit Picker component is displayed. */
  showUnitBuilder = false;

  writeOrdinalSuffixOfNumber = WriteOrdinalSuffixOfNumber;

  isCheckedout = false;

  /* ...Lookup Table data array holder section... */
  public armyData: Army[] = [];
  public luArmyData: LUArmy[] = [];
  public battleData: Battle[] = [];
  public statesData: State[] = [];
  public ranksData: Rank[] = [];
  public rankCatsData: RankCategory[] = [];
  public priWeaponsData: PrimaryWeapon[] = [];
  public weaponsData: Weapon[] = [];
  public regiments: Regiment[] = [];
  public branchesOfService: BranchOfService[] = [];
  public companyLetters: string[] = [];
  public luSources: LUSource[] = [];
  public qMLinks: QMManualLink[] = [];
  /* ..End LU Table data array holder section... */

  /* ...ColumnModel config array section (for use with the Table-Editor components)... */
  public armyColumnData: IColumnModel[] = [];
  public luSourceData: IColumnModel[] = [];
  // public keywordsColumnData: IColumnModel[] = Keyword.keywordColumnData();
  public unitLinksColumnData: IColumnModel[] = [];
  public regimentColumnData: IColumnModel[] = [];
  public branchColumnData: IColumnModel[] = [];
  public datesColumnData: IColumnModel[] = [];
  public datesMonthsDropdown = MONTHS;
  public weaponsColumnData: IColumnModel[] = []; // for creating new weapons
  public weaponLinksColumnData: IColumnModel[] = [];
  public newRegimentColumnData: IColumnModel[] = [];
  public primaryWeaponsColumnData: IColumnModel[] = PrimaryWeapon.CreatePrimaryWeaponColumnData();
  public rankColumnData: IColumnModel[] = [];
  public rankCatColumnData: IColumnModel[] = [];
  public battleColumnData: IColumnModel[] = [];
  /* ..End ColumnModel config array section... */

  /* ... Table-Editor RowModel array holder section... */
  public datesTableRows: IRowModel[] = [];
  public weaponsTableRows: IRowModel[] = []; // For creating new weapons
  public weaponLinksTableRows: IRowModel[] = [];
  public keywordsTableRows: IRowModel[] = [];
  public newArmyRowData: IRowModel[] = [];
  public newUnitRowData: IRowModel[] = [];
  public regimentTableRows: IRowModel[] = [];
  public branchTableRows: IRowModel[] = [];
  public newRankTableRows: IRowModel[] = [];
  public newRankCatTableRows: IRowModel[];
  public primaryWeaponsTableRows: IRowModel[] = [];
  public battleTableRows: IRowModel[] = [];
  public newLUSourceTableRows: RowModel[];
  public boundImageSetRows = [];
  public boundImageSetsCols: IColumnModel[] = [];
  public totalIndividualRecords: number;

  /* ... Data loader Observable$ ... */
  unitData$: Observable<UnitLinking[]>;
  weaponsData$: Observable<WeaponLinking[]>;
  individualsData$: Observable<FilterParams<ImageIndividual>>;
  qmsData$: Observable<QMManualLink[]>;
  datesData$: Observable<ImageDate[]>;
  boundSetData$: Observable<ImageFile[]>;

  /** Used by Rapid Keyword Entry component to get a "new-ed" instance */
  nextKeyword: LU_Keyword = new LU_Keyword();
  nextKeywordText: string;
  /** Default results per page for units table-editor instance */
  unitRpp = 5;

  boundSetImagesPage = 1; // rpp for bound set images at a time.
  loadingNextPage = false;
  /** When true, the IndividualEntry component will be shown. */
  showIndividualEditor: boolean;
  /** Temp variable for storing new-ed ImageIndividual */
  individualData: ImageIndividual;

  /** Used to prevent double-pressing Save button and display the "Please wait" text when saving to server. */
  public saveInProgress = false;

  /* ...Table-editor Notifier section... */
  keywordsNotifier = new Notifier();
  datesNotifier = new Notifier();
  unitsNotifier = new Notifier();
  weaponsNotifier = new Notifier();
  filterNotifier = new Notifier();
  relatedImagesNotifier = new Notifier();
  sequenceNumberNotifier = new Notifier();
  boundImageSetsNotifier = new Notifier();
  battleNotifier = new Notifier();
  allImageTypes: ImageType[] = [];
  /* ...End table-editor Notifier section... */

  weaponsRows: Weapon[];
  newWeaponCols: any;
  newWeaponCatSequence = false;
  newEntityWeaponBackup = null;
  weaponsRowBackup: IRowModel;
  /** Array for the Related Image Sets this record belongs to. */
  recordSets: RelatedSetModel[] = [];
  allRelatedImageSets;
  relatedImageSet = new RelatedImageSetViewDataModel();
  relevantRelatedImageSetsForCurrentRecord = null;
  historyThumbnailsData;


  /** Determines the maximum pixel height of table-editors on this view. */
  tableMaxHeight = '137px';
  /** Sets the options for Results Per Page dropdown of table-editors on this view. */
  rppOptions = [5, 10, 25, 50, 100];
  sequenceNumberCols: IColumnModel[];
  sequenceNumberRows: RelatedSetModel[];

  boundImageCarouselArray = [];

  recordNoInSet = 0;
  totalRecordsInSet = 0;
  isChildCarouselOpen = false;

  /** Sets Individual-Entry component in Edit or Add mode.
   * If false, Individual-Entry starts in "Add mode."
   * If true, Individual-Entry starts in "Edit mode."
   */
  individualEditMode: boolean;

  /** The toolbar items and config for EJ2 RTF component.
   *
   * @property 'items' array contains string names of the buttons to show in the order for which they should appear.
   * Use '|' to add a delimiter graphic.
   * @property 'size' object is used for the fontSize dropdown.
   * @property 'fontFamilies' object is used for the list of fonts available.
   */
  public tools = AppComponent.rtfTools;
  public size = AppComponent.rtfSize;
  public fontFamilies = AppComponent.rtfFontFamilies;

  public rtfFullscreen = false; // whether the component is fullscreen (to set the component to fullscreen, you need to access the element reference not set this boolean)
  /** The height in pixels for the EJ2 RTF component. */
  rtfHeight = '400px';
  /** The first index of the thumbnails array to display within the carousel */
  imageCarouselFirstIndex: number;
  /** The last index of the thumbnails array to display within the carousel */
  imageCarouselLastIndex: number;
  /** An array of all of the images within one particular bound image set */
  imageModels: ImageFile[] = [];
  /** An array of all of the images currently displayed within the carousel */
  boundImageSetTableRows = [];

  subscriptionList: Subscription[] = [];
  imageHistory$: Observable<ImageFile[]>;

  librarian = false;

  public thumbnailGridMode = libraryViewModes.listMode;

  /** Temp storage for previous value of a table-editor row, to be used when user cancels changes. */
  private newEntityBackup: IRowModel;
  /* ... End Table-Editor RowModel section... */

  private delModal: StarbaseModalOptions; // storage for the config options for the delete confirmation modal dialog
  private keyHelpModal: StarbaseModalOptions; // storage for the config options for the keyboard shortcuts help modal dialog
  private okModal: StarbaseModalOptions;

  private checkOutStatusChanged = false;

  /* ... Subscription section... */
  private getSubscriber: Subscription;
  private updateSubscriber: Subscription;
  private deleteSubscriber: Subscription;
  private lookupDataSubscriber: Subscription;
  private recordSetsSubscriber: Subscription;
  private weaponsSubscriber: Subscription;
  private relevantRSVSubscriber: Subscription;
  /* ... End subscription section ... */

  /* ... Ledger navigation properties */
public currentLedger: RelatedSetModel = null;
public currentSequenceNumber = 1;
public totalLedgerImages = 0;
public isInLedgerMode = false;
public ledgerWindowSize = 10;
public isLoadingLedgerData = false;
public sequenceNumberInput = new FormControl();
public ledgerImages: ImageFile[] = [];
public currentLedgerImageIndex = 0
public ledgerImagesPage = 1; // For pagination if needed
public loadingMoreLedgerImages = false;
  /* ...End Ledger navigation properties */

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private loginSvc: StarbaseLoginService,
    private imgSvc: ImageService,
    private notiSvc: StarbaseNotificationService,
    private reqSvc: ContactRequestService,
    private gHist: GalleryHistoryService,
    private modalSvc: StarbaseModalDialogService,
    private overlaySvc: StarbaseModalOverlayService,
    private lookupSvc: LookupDataService,
    private keywordSvc: KeywordDataService,
    private galleryTypeSvc: GalleryTypeService,
    private renderer: Renderer2,
    private appInsights: AppInsightsService,
    private readonly sanitizer: DomSanitizer,
    private appComponent: AppComponent,
    public sbCmpMsg: StarbaseComponentMessageService,
    public appGlobalsSvc: AppGlobalsService,
    private webSocketSvc: WebSocketService,
    private transLogSvc: TransactionLogService,
    private location: PlatformLocation,
    private titleSvc: Title,
    private breakpointService: BreakpointService,
    private cd: ChangeDetectorRef) { }

  get imageKeywordsMap() {
    return this.imageData.imageKeywords.map(kl => kl.lU_Keyword);
  }

  get datesDisplayerColumns(): string[] {
    return this.imageData.typeOfImageId === ImageTypes.Ordnance_Returns ?
      ['Month', 'Day', 'Year', 'Quarter'] : ['Month', 'Day', 'Year'];
  }

  gridLargeMode() {
    this.galleryTypeSvc.setViewMode('gridLargeMode');
    this.thumbnailGridMode = libraryViewModes.gridLargeMode;
  }

  public get canEdit(): boolean {
    return this.isAdmin || this.loggedInUser.isInUserGroup('Librarian');
  }

  public get isTrialUser(): boolean {
    return !this.isAdmin && !this.loggedInUser.isInUserGroup('Librarian') && !this.loggedInUser.isInUserGroup('Subscriber');
  }

  ngOnInit() {

    this._subscription = this.breakpointService.handset$.subscribe(
      isHandset => {
        this.isHandset = isHandset;

        if (this.isHandset) {
          this.gridLargeMode();
        }
      }
    );

    this._imgRepairSubscription = this.galleryTypeSvc.libraryImagesRepaired.subscribe(() => {
      this.recordNoInSet = this.calcRecordNoInSet(); this.totalRecordsInSet = this.calcTotalRecordsInSet();
    });

    this.subscriptionList.push(this._imgRepairSubscription);

    if (this.isHandset) {
      const rows: NodeListOf<HTMLElement> = document.querySelectorAll('.row');

      rows.forEach((row: HTMLElement) => {
        row.style.margin = '0';
      });
    }

    this.isCrawler = robots.test(window.navigator.userAgent);

    this.getHistoryThumbnails();


    if (this.isCrawler) {
      const id = +this.route.snapshot.paramMap.get('id');
      this.getSubscriber = this.imgSvc.getData(this.imgSvc.getOneForCrawler, id).subscribe(d => {
        try {
          this.imageData = d;
          this.displayName = this.processDisplayName(this.imageData);
          UnitLinking.setupUnitLinkCollection(this.imageData.units);
          ImageIndividual.setupCollection(this.imageData.imageIndividuals);
          // eslint-disable-next-line max-len
          this.titleSvc.setTitle('Research Arsenal: ' + this.displayName);
          this.loaded = true;
        } catch (e) {
        console.log(e);
          this.handleLoadingError(e);
         }
      },
      err => this.handleLoadingError(err));
      return;
    }
    this.errorMessage = '';
    this.simpleIndex = false;
    this.getImageTypes();
    this.isAdmin = this.loginSvc.getUserModel().isAdmin();
    this.librarian = this.loginSvc.getUserModel().isInUserGroup('Librarian');
    this.loggedInUser = this.loginSvc.getUserModel();
    if (this.isTrialUser) {
      this.loadPlaceHolderData();
    } else {
      this.getImageFile();
      this.keyHelpModal = new StarbaseModalOptions(
        'Keyboard Shortcuts',
        '',
        [
          new StarbaseModalButton(
            'Okay', () => {
              this.renderer.selectRootElement('#nameField').focus(); this.modalSvc.closeModal('User pressed Okay');
            })
        ],
        StarbaseModalTypes.Info,
        this.keystrokeHelpModal);
      setTimeout(() => {
        console.log(this.ImageTypes);
      }, 5000);

      this.sequenceNumberInput = new FormControl();
      this.sequenceNumberInput.valueChanges
        .pipe(
          debounceTime(500),
          distinctUntilChanged()).subscribe(value => {
        if (value && !isNaN(value) && this.isInLedgerMode) {
          let displaySequence = parseInt(value);
          
          // Auto-correct to valid range
          if (displaySequence < 1) {
            displaySequence = 1;
            this.sequenceNumberInput.setValue(1, {emitEvent: false});
          } else if (displaySequence > this.totalLedgerImages) {
            displaySequence = this.totalLedgerImages;
            this.sequenceNumberInput.setValue(this.totalLedgerImages, {emitEvent: false});
          }
          
          // Navigate to the image at this sequence and center carousel
          const targetIndex = displaySequence - 1;
          if (targetIndex !== this.currentLedgerImageIndex && this.ledgerImages[targetIndex]) {
            const targetImage = this.ledgerImages[targetIndex];
            this.handleLedgerCarouselSelection(targetImage.uid);
          }
        }
      });

      const imageUpdatedSubscription = this.webSocketSvc.imageUpdatedTrigger$.subscribe(
        (data) => {
          const recordUid = data[0];
          const user = data[1];
          if (recordUid === this.imageData.uid  && user !== this.loggedInUser.user && this.editMode) {
            this.enableUpdateModal(
              `This record has been updated by another user.
               Please copy or make note of any changes, then click "Continue" to load the latest version.`,
              'Continue'
            ).subscribe(
              () => {
                this.cancelChanges();
                this.startEditMode();
              }
            );
          } else if (recordUid === this.imageData.uid && user !== this.loggedInUser.user && !this.isTrialUser) {
            this.notiSvc.postNotification(
              this.notiSvc.notificationBuilder(
                'Image Record Updated',
                'This record has been updated by another user.',
                undefined, undefined, StarbaseNotificationSentiment.Info
              )
            );
            this.getImageFile(this.imageData.uid);
          }
        }
      );

      this.subscriptionList.push(imageUpdatedSubscription);
      this.webSocketSvc.setupImageConnection();
    }

    this.getRelatedImageSetData(this.imageData?.uid);
    this.galleryTypeSvc.checkLibraryImages();
  }

  ngOnDestroy() {
    this.titleSvc.setTitle('Research Arsenal');
    if (this.loaded && !this.isTrialUser) {
      // add to history service since we have successfully loaded the record and we are leaving the screen
      this.gHist.addImageToHistory(this.imageData);
    }

    if (!this.isTrialUser) {
      this.webSocketSvc.disconnectImageConnection();
    }

    this.subscriptionList.forEach(s => {
      if (s) {
        s.unsubscribe();
      }
    });
  }

  setFullscreenRTF(state: boolean) {
    this.rtfFullscreen = state;
    const navbar = document.getElementsByClassName("mainNavDiv")[0] as HTMLDivElement;
    if (navbar) {
      if (this.rtfFullscreen) navbar.style.display = "none";
      else navbar.style.display = "block";
    }

    const toolbar = document.getElementById("alltoolRTE_toolbar") as HTMLDivElement;
    if (toolbar) {
      if (this.rtfFullscreen) toolbar.style.margin = "60px";
      else toolbar.style.marginTop = "0px";
    }

    if (!this.rtfFullscreen) {
      this.rtfComp?.fullScreenModule?.destroy();
    }
  }

  ngAfterViewInit() {
    if (!this.isTrialUser && !this.isCrawler) {
      this.librarySearchText = this.galleryTypeSvc.getCurrentLibraryFilters(
      this.galleryTypeSvc.getLastResultsPerPageSetting(35)).searchPhrase;
      this.gHist.getImageHistory();
      setTimeout(() => {
        this.singleImageViewWrapper?.nativeElement.focus(); // so the keyboard shortcuts listener has focus
      }, 500);
    }
  }

  connectAnchorLinks() {
    const anchorLinks = document.getElementsByClassName('anchorLink');
    for(let i = 0; i < anchorLinks.length; i++) {
      const anchorLink = anchorLinks.item(i);
      const uid = +anchorLink.getAttribute('id').split('_')[1];
      anchorLink.addEventListener('click',() => {
          this.goToImage(uid);
        });
    }
  }

  loadPlaceHolderData() {
    const date = new Date();
    this.imageData = new ImageFile();
    this.imageData.name = 'Research Arsenal';
    this.displayName = this.imageData.name;
    this.imageData.originalFileName = '';
    this.imageData.year = date.getFullYear();
    this.imageData.month = date.getMonth();
    this.imageData.day = date.getDay();
    this.imageData.location = 'United States';
    this.imageData.imageKeywords = [];
    const army = new Army();
    const luArmy = new LUArmy();
    luArmy.armyName = 'Ohio Volunteer Cavalry';
    army.army = luArmy;
    army.regionalName = 'OVC';
    army.armyName = 'Research Arsenal';
    this.imageData.army = army;
    this.imageData.callNo = 'Sample';
    this.imageData.corps = 501;
    this.imageData.filePath = '../../assets/11th%20OVC%20Logo%203x3.png';
    this.imageData.fileType = 'png';
    const state = new State();
    state.abbreviation = 'OH';
    state.state_Name = 'Ohio';
    this.imageData.locationState = state;
    this.imageData.mounted = false;
    this.imageData.notes = 'The 11th Ohio Volunteer Cavalry';
    this.imageData.portrait_Field = 'Portrait';
    this.imageData.regionalName = '';
    const imageDate = new ImageDate(date.getMonth());
    imageDate.day = date.getDay();
    imageDate.year = date.getFullYear();
    this.imageData.relevantDates = [
      imageDate
    ];
    const imageType = new ImageType();
    imageType.typeOfImage = 'Photos';
    this.imageData.typeOfImage = imageType;
    this.imageData.typeOfImageId = ImageTypes.Photos;
    this.loaded = true;
    this.appComponent.showSubscribeMessage(false);
  }

  getImageTypes() {
    this.lookupSvc.getAllRequisiteData<ImageType>(this.lookupSvc.imageTypesUrl).subscribe(a => {
      this.allImageTypes = a;
    });
  }

  mapQMLinkArray(isEditable = false) {
    let resultArray: QMManual[] = [];
    if (this.imageData.quarterMasterManuals && this.imageData.quarterMasterManuals.length) {
      resultArray = this.imageData.quarterMasterManuals.map(linkItem => {
        const item = linkItem.qM_ManualModel;
        item.editable = isEditable;
        item.createdByUser = linkItem.createdByUser;
        item.createdDateTime = linkItem.createdDateTime;
        return item;
      });
    }

    return resultArray;
  }

  handleSequenceInputKeydown(event: KeyboardEvent) {
    if (event.key === 'Enter') {
      const value = this.sequenceNumberInput.value;
      if (value && !isNaN(value)) {
        const sequenceNum = parseInt(value);
        if (sequenceNum >= 1 && sequenceNum <= this.totalLedgerImages) {
          const targetImage = this.ledgerImages[sequenceNum - 1];
          if (targetImage) {
            this.navigateToLedgerImage(targetImage, sequenceNum);
          }
        }
      }
    }
  }

  navigateToLedgerInLibrary() {
    if (this.currentLedger) {
      this.galleryTypeSvc.LedgerSetsMode = false;
      
      // Clear existing filters and search
      this.galleryTypeSvc.clearCurrentFilterOptions();
      
      // Set up filter params to show this ledger's images
      const filters = new FilterParams<ImageFile>();
      filters.filters = [['RelatedSetUID', this.currentLedger.uid.toString()]];
      filters.sortFields = ['SequenceNumber'];
      filters.sortAsc = true;
      filters.page = 1;
      filters.rpp = 35;
      filters.searchPhrase = '';
      
      // Store the ledger set info for breadcrumb/navigation
      this.galleryTypeSvc.storeRelatedSetNameFilter(this.currentLedger.name, this.currentLedger.uid);
      this.galleryTypeSvc.storeRelatedSetUIDFilter(this.currentLedger.uid);
      
      // Set the filters and clear existing library images
      this.galleryTypeSvc.setCurrentLibraryFilters(filters);
      this.galleryTypeSvc.clearLibraryImages();
      
      // Navigate to library
      this.router.navigate(['/library']);
    }
  }

  viewQMManual(manual: QMManual) {
    this.router.navigateByUrl('/quartermaster-manuals/' + manual.uid);
  }

  handleChangeImageType(e: number) {
    this.imageData.typeOfImageId = e;
    this.imageData.typeOfImage = this.allImageTypes.find(t => t.uid === e);
    this.setFormDirty();
  }

  /** Checks if the imageForm has been edited and returns an observable of true
   *  or calls the `confirmLeavePageModal` method,
   *  which returns an observable of true or false depending on the user's choice */
  unsavedChangesCheck(): Observable<boolean> {
    try {
      if (!this.imageForm.pristine) {
        return this.confirmLeavePageModal();
      } else {
        return of(true);
      }
    } catch { // imageForm is not accessible means we were not in edit mode
      return of(true);
    }
  }
  /** Generates a Starbase modal dialog instance,
   *  asking the user if they would like to lose their unsaved changes. Returns as an observable of the user's answer. */
  public confirmLeavePageModal(): Observable<boolean> {
    const m = new Observable<boolean>(obj => {
      const modal = new StarbaseModalOptions(
        'Discard unsaved changes?', 'You have unsaved changes to this record. Do you want to leave the page anyway?', [
        new StarbaseModalButton('Yes, lose changes', () => {
          obj.next(true);
          this.modalSvc.closeModal('User left page');
        }), // set up modal
        new StarbaseModalButton('No, I worked hard on that!', () => {
          obj.next(false);
          this.modalSvc.closeModal('User stayed on page');
        }), // set up modal button
      ], 2);
      modal.dismissable = false;
      this.modalSvc.postModal(modal); // display modal
    });
    return m;
  }

  

  goToImage(id: number) {
    this.handleSelectImageCarouselThumbnail(this.imageModels.find(i => i.uid === id));
  }

  handleSelectImageCarouselThumbnail(imageModel: ImageFile) {
    // eslint-disable-next-line curly
    if (isDevMode()) {
      // eslint-disable-next-line no-console
      console.info('Switching bound image display to ' + imageModel.uid);
    }
    this.imageData.filePath = this.correctedFilepath(imageModel);
    this.displayName = this.processDisplayName(imageModel);
    if (this.boundImages) {
      this.boundImages.displayName = this.displayName;
    }

    // scroll RTF section
    const el = document.querySelector('#rtfAnchor_' + imageModel.uid);
    if (el && !this.isHandset) {
      el.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
    }
  }

  childCarouselToggle(event) {
    this.isChildCarouselOpen = event;
  }

  /** Some pre-process c0de for entering edit mode.
   *  Double-checks the "admin" rights directly from the loginSvc before allowing edit mode to begin.
   *  Reports to server if this is not allowed.
   * Sets focus on the 'Name' field (first text input field).
   * Gets some additional data needed from the server.
   */
  startEditMode(): void {
    if (!this.loginSvc.getUserModel().isAdmin()
      && !this.loggedInUser.isInUserGroup('Librarian')) { // extra check for permissions to enable edit mode
      this.appInsights.logError(
        new Error('Non-admin attempted to invoke edit mode on single image view!'), { imageID: this.imageData.uid.toString() });
      console.warn('Non-admin attempted to invoke edit mode on single image view.');
      this.notiSvc.postNotification(
        this.notiSvc.notificationBuilder(
          'Edit Mode restricted',
          'You do not have the needed permissions to enter edit mode. Please contact an administrator.',
          undefined,
          3000,
          StarbaseNotificationSentiment.Notice));
      return; // ^^ post notification
    }
    this.appInsights.logEvent('Edit mode requested.');
    this.loaded = false;
    const forks = this.dataLookupCallsArray();
    this.lookupDataSubscriber =
    forkJoin(forks).subscribe(
      () => {
        this.getUnits();
        this.getWeapons();
        this.editMode = true;
        // this.renderer.selectRootElement('#nameField').focus(); // focus on first field
        this.imageData.weapons.forEach(obj => { // for each weapon
           if (obj.uid !== 0) { // if the weapon is not new
            obj.weapon_Category = obj.weapon.primaryWeapon.weapon_Category; // reassign weapon category so that its not undefined
          }
        });
        this.getRecordSets(this.imageData.uid);
        this.getRelatedImageSetData(this.imageData.uid);
        if (this.imageData.transcription) {
          this.imageData.transcription = this.originalTranscriptionText.replace('SafeValue must use [property]=binding:', '')
            .replace('(see http://g.co/ng/security#xss)', '');
        }
        setTimeout(() => {
          this.imageForm.controls['orderNo']?.markAsDirty();
          if (this.imageForm.valid) {
            this.imageForm.controls['orderNo']?.markAsPristine();
          }
        }, 250);
      },
      e => {
        this.notiSvc.postNotification(this.notiSvc.notificationBuilder(
          'Data Load Failure',
          'Some of the requisite data for edit mode did not load. Please try again.',
          undefined, undefined, StarbaseNotificationSentiment.Error));
        this.loaded = true;
        console.error(e);
      },
      () => this.loaded = true
    );
    this.subscriptionList.push(this.lookupDataSubscriber);
  }
  startThumbnailEditMode(): void {
    this.modalSvc.postModal(
      new StarbaseModalOptions(
        'Confirmation?',
        'Please confirm if you would like to regenerate a thumbnail for the current record?',
        [
          new StarbaseModalButton(
            'Confirm',
            () => {
              this.isGeneratingThumbnail = true;
              const temp = this.imgSvc.regenerateImageThumbnail(this.imageData).pipe(
                share(),
                finalize(() => this.isGeneratingThumbnail = false)
              );
              const notify = this.notiSvc.notificationBuilderAsync(
                'Please Wait',
                'Generating the thumbnail may take a moment.',
                null,
                temp,
                1000,
                StarbaseNotificationSentiment.Notice,
              );
              this.notiSvc.postNotification(notify);
              temp.subscribe((i) => {
                this.imageData.thumbnailPath = i.thumbnailPath;
                this.modalSvc.postModal(
                  new StarbaseModalOptions(
                    'New Thumbnail Preview',
                    'Updated thumbnail:',
                    [
                      new StarbaseModalButton(
                        'Close',
                        () => {
                          this.modalSvc.closeModal('Closed by the user.');
                          /* to refresh the boundSet images once a new thumbnail has been generated else the boundset images will show the
                          previous thumbnail unless the user refreshes the page.*/
                          const idx = this.galleryTypeSvc.getFilteredImageIds().findIndex(r => r === this.imageData.uid);
                          this.switchRecord(this.galleryTypeSvc.getFilteredImageIds()[idx]);
                        })
                      ],
                      StarbaseModalTypes.Info,
                      this.rotateThumbnailModal
                  )
                );
              },
              (e) => {
                notify.content = 'Thumbnail regeneration has failed.';
              });
              this.modalSvc.closeModal('Closed by the user');
            }),
            new StarbaseModalButton(
             'Decline',
            () => {
              this.modalSvc.closeModal('Closed by the user.');
            })
          ],
          StarbaseModalTypes.Info,
      )
    );
  }

  /** Deals with delete confirmation for deleting related image set memberships */
  handleDeleteRelatedImageRecord(row: IRowModel) {
    if (row.uid === 0) {
      return false;
    }
    const yesBtnCb = () => {
      this.lookupSvc.deleteRelatedImageSet(row).subscribe(() => {
        this.sequenceNumberNotifier.valueChanged(row.uid); // tell the table-editor to remove the specified row
        this.relatedImagesNotifier.valueChanged(null); // tell the table-editor to remove the specified row
      }, e => {
        this.notiSvc.postNotification(
          this.notiSvc.notificationBuilder(
            'Deletion failed',
            'Could not remove the related image set from this record. '
            + e['friendly'],
            undefined, undefined, StarbaseNotificationSentiment.Error));
      });
    };
    const noBtnCb = () => { };
    this.handleDeleteSubtableRecord('Related Image Set', 'the link to this image set', yesBtnCb, noBtnCb);
  }

  requestTranscription(){
    this.modalSvc.postModal(
      new StarbaseModalOptions(
        'Request Transcription',
        // eslint-disable-next-line max-len
        'Sending a request for transcription will notify the Research Arsenal Librarians that you would like this record transcribed. Would you like to submit your request?',
        [
          new StarbaseModalButton(
            'Yes',
            () => {
              this.reqSvc.requestTranscription(this.imageData).pipe(
                share()
              ).subscribe({
                next: (response) => {

                  this.notiSvc.postNotification(this.notiSvc.notificationBuilder(
                    'Success',
                    'Request for Transcription successfully sent.',
                    StarbaseNotificationTypes.Success));
                  this.modalSvc.closeModal('Request successful.');
                },
                error: (error) => {
                  this.notiSvc.postNotification(this.notiSvc.notificationBuilder(
                    'Error',
                    'Request for Transcription failed to send.',
                    StarbaseNotificationTypes.Error));
                  console.error(error);
                  this.modalSvc.closeModal('Request failed.');
                }
              });
            }),
            new StarbaseModalButton(
             'No',
            () => {
              this.modalSvc.closeModal('Closed by the user.');
            })
          ],
          StarbaseModalTypes.Info,
      )
    );
  }

  handleModifySequenceNumber(e: RelatedSetLinkingModel) {
    this.lookupSvc.putRequisiteData<RelatedSetLinkingModel>(this.lookupSvc.putRecordSetsUrl, e.imageModelId.toString(), e).subscribe(data => {
      this.getRecordSets(this.imageData.uid);
      this.getRelatedImageSetData(this.imageData.uid);
      this.notiSvc.postNotification(
        this.notiSvc.notificationBuilder(
          'Success',
          'Related Image set sequence updated', undefined, undefined, StarbaseNotificationSentiment.Success));
    });
  }

  /** Opens the pre-configured modal for keyboard shortcut help */
  openKeyHelpModal() {
    this.modalSvc.postModal(this.keyHelpModal);
  }

  handleModifyBoundImageSets(e) {
    if (typeof(e.sequenceNumber) === 'number' || !isNaN(parseInt(e.sequenceNumber, 10))) { // if the seq number is valid
      if (e.imageModel.uid === this.imageData.uid) { // if the selected row is the cover photo
        this.notiSvc.postNotification(
          this.notiSvc.notificationBuilder(
            'Failure',
            `Changing the sequence of the cover photo (Image #1) isn\'t permitted.
             The only way to change Image #1 is to delete the entire Bound Set (using the Lookup Tables screen)
              and recreate it in the Gallery screen.`,
            undefined, 7500, StarbaseNotificationSentiment.Error));
        this.boundImageSetTableRows.forEach(row => {
          if (row === e) {
            this.getBoundImageSetForThisImage();
            }
          });
      } else { // if the selected row is not the cover photo
        if (e.sequenceNumber !== 0) {
          console.log(e);
          this.lookupSvc.putRequisiteData(this.lookupSvc.putBoundRecordSetsUrl, e.imageModel.uid.toString(), e).subscribe(
            () => {
              this.notiSvc.postNotification(
                this.notiSvc.notificationBuilder(
                  'Success',
                  'Bound Image set sequence updated', undefined, undefined, StarbaseNotificationSentiment.Success));
            this.setFormDirty();
            this.getBoundImageSetForThisImage(); // reload the bound image data in order to reflect this change
          }, () => {
              this.notiSvc.postNotification(
                this.notiSvc.notificationBuilder(
                  'Failure',
                  'Could not save duplicate sequence number', undefined, undefined, StarbaseNotificationSentiment.Error));
            this.boundImageSetTableRows.forEach(row => {
              if (row === e) {
                setTimeout(() => {
                  row.editMode = true;
                }, 1);
                }
              });
          });
        }
      }
  } else { // if the seq number is not valid
      this.notiSvc.postNotification(
        this.notiSvc.notificationBuilder(
          'Failure',
          'Please enter a valid number', undefined, undefined, StarbaseNotificationSentiment.Error));
    this.getBoundImageSetForThisImage();
    }
  }

  handleDeleteBoundImage(e: BoundImageSet) {
    if (e.imageModel.uid !== this.imageData.uid) {
      const modal = new StarbaseModalOptions(
        'Confirm Deletion',
        'This action will remove the record from the bound image set, but will not delete the record itself.', [
        new StarbaseModalButton('Yes', () => {
          this.lookupSvc.deleteBoundImageFromSet(e).subscribe(event => {
            this.boundImageSetsNotifier.valueChanged(null); // tell the table-editor to remove the specified row
            this.notiSvc.postNotification(
              this.notiSvc.notificationBuilder(
                'Success',
                'Image removed from bound image set.', undefined, undefined, StarbaseNotificationSentiment.Success));
            this.getBoundImageSetForThisImage(); // reload the bound image data in order to reflect this change
          }, event => {
            this.notiSvc.postNotification(
              this.notiSvc.notificationBuilder(
                'Failure',
                `Removing the cover photo for a bound set is not permitted. 
                To delete an entire bound set, you must use the Lookup Tables screen.`,
                undefined, undefined, StarbaseNotificationSentiment.Error));
          });
          this.modalSvc.closeModal('User Deleted Row');
        }),
        new StarbaseModalButton('No', () => {
          this.modalSvc.closeModal('User did not delete row');
        }),
      ], 3);
      modal.dismissable = true;
      this.modalSvc.postModal(modal);
    } else {
      this.notiSvc.postNotification(
        this.notiSvc.notificationBuilder(
          'Failure',
          `Removing the cover photo for a bound set is not permitted.
           To delete an entire bound set, you must use the Lookup Tables screen.`,
          undefined, undefined, StarbaseNotificationSentiment.Error));
    }
  }

  /** Handles keyboard events and translating between Mac and Windows keystrokes.
   *
   * @param event `KeyboardEvent` the keyboard event to process. Should usually be a keydown event for best results. */
  handleKeyboardEvents(event: KeyboardEvent) { // best for keydown bindings
    // eslint-disable-next-line curly
    if (this.saveInProgress) return; // do not allow further keyboard form actions if we are in the middle of saving to server.
    const agnosticModifierKey = (navigator.platform.match('Mac')) ? event.metaKey : event.ctrlKey;

    // Meta key handling (Command ⌘ on Apple hardware) or Ctrl key handling for standard Windows US qwerty boards.
    const charCode = String.fromCharCode(event.which).toLowerCase();
    if (agnosticModifierKey && charCode === 's' && this.editMode) {
      // Cmd/Ctrl + S action (Save form)
      event.preventDefault();
      this.submitChanges();
    } else if (agnosticModifierKey && charCode === 'z' && this.editMode && !this.imageForm.pristine) {
      // Cmd/Ctrl + Z action (Cancel editing)
      event.preventDefault();
      this.cancelChanges();
    } else if (agnosticModifierKey && charCode === 'z' && this.editMode && this.imageForm.pristine) {
      // Cmd/Ctrl + Z action (Cancel editing (nothing edited yet))
      event.preventDefault();
      this.editMode = false;
      this.singleImageViewWrapper?.nativeElement.focus();
    } else if (agnosticModifierKey && charCode === 'k' && this.editMode) {
      // Cmd/Ctrl + K action (rapid keyword entry)
      event.preventDefault();
      // this.toggleRapidKeysOpen();
      // setTimeout(() => {
      //   try {
      //     this.KeywordsInputEl.nativeElement.scrollIntoView(
      // { alignToTop: true, behavior: 'smooth', block: 'center', inline: 'nearest' });
      //     this.KeywordsInputEl.nativeElement.focus();
      //   } catch {}
      // }, 400);
    } else if (agnosticModifierKey && charCode === 'e' && !this.editMode) {
      // Cmd/Ctrl + E action (enter edit mode)
      event.preventDefault();
      this.startEditMode();
    } else if (agnosticModifierKey && event.keyCode === 38) {
      // OR Cmd/Ctrl + ↑ [up arrow key] action (enter zoom mode)
      event.preventDefault();
      if (this.zoomMode) {
        this.exitZoom();
      } else {
        this.fullScreenImage();
      }
    } else if (event.keyCode === 187 || event.keyCode === 107) {
      if (!this.zoomMode) {
      return;
      }
      // Shift + =/+ [Equals/Plus Key] action (zoom in)
      this.zoomInBtn?.nativeElement.click();
    } else if (event.keyCode === 189 || event.keyCode === 109) {
      if (!this.zoomMode) {
        return;
      }
      // (-) [minus key] action (zoom out)
      this.zoomOutBtn?.nativeElement.click();
    } else if (agnosticModifierKey && event.keyCode === 37) {
      // Cmd + <- [left arrow key] action (Move to Prev record)
      event.preventDefault();
      this.goPrevRecord(event);
    } else if (agnosticModifierKey && event.keyCode === 39) {
      // Cmd + -> [right arrow key] action (Move to Next record)
      event.preventDefault();
      this.goNextRecord(event);
    } else if (event.keyCode === 27) {
      if (!this.zoomMode) {
        return;
      } else {
      this.exitZoom();
      }
    }
  }

  /* ....TYPEAHEAD SECTION .... */

  broadTypeaheadSearch(entity: string,
    property: string,
    clickSubject?: Subject<string>,
    focusSubject?: Subject<string>,
    element?: NgbTypeahead): (text: Observable<string>) => Observable<readonly any[]> {
    return (text$: Observable<string>) => {
      if (clickSubject && !element) {
 console.warn('Click subject used, but no ngbTypeahead component specified.'); clickSubject = null;
}
      const debouncedText$ = text$.pipe(debounceTime(DEFAULT_DEBOUNCE), distinctUntilChanged());
      const clicksWithClosedPopup$ = clickSubject ? clickSubject.pipe(filter(() => !element.isPopupOpen())) : of('');
      const inputFocus$ = focusSubject || of('');
      return merge(debouncedText$, inputFocus$, clicksWithClosedPopup$).pipe(
        switchMap(term =>
          this.lookupSvc.typeaheadSearch(term, [entity], 5, null, [property]).pipe(
            tap(() => this.setFormDirty()),
            map((r: TypeaheadResults) => r.matches[0].hits[property]),
            catchError((e) => this.typeaheadFailure(e, entity + ': ' + property))
          ))
      );
    };
  }

  keywordTypeaheadSearch(element: NgbTypeahead): (text: Observable<string>) => Observable<readonly any[]> {
    return (text$: Observable<string>) => {
      const debouncedText$ = text$.pipe(debounceTime(DEFAULT_DEBOUNCE), distinctUntilChanged());
      const clicksWithClosedPopup$ = this.keywordClick$.pipe(filter(() => !element.isPopupOpen()));
      return merge(debouncedText$, this.keywordFocus$, clicksWithClosedPopup$).pipe(
        switchMap(term => this.lookupSvc.typeaheadSearch(term, ['lu_keyword'], 5, null, ['keyword']).pipe(
          map((r: TypeaheadResults) => {
            if (r.matches[0].hits['keyword']) {
              const hk = this.imageKeywordsMap.map(g => g.keyword.toLowerCase()); // temp comparison arr
              return r.matches[0].hits['keyword'].filter(h =>
                !hk.includes(h.toLowerCase()));
            } else {
              return [];
            }
          }),
          catchError((e) => this.typeaheadFailure(e, 'lu_keyword: keyword'))
        ))
      );
    };
  }

  interceptTypeaheadSelection(event: NgbTypeaheadSelectItemEvent) {
    if (this.ignoreTypeaheadSuggestion) {
      event.preventDefault();
      this.ignoreTypeaheadSuggestion = false;
    }
  }

  // weaponNameSearch = (text$: Observable<string>) =>
  //   text$.pipe(
  //     debounceTime(DEFAULT_DEBOUNCE),
  //     distinctUntilChanged(),
  //     switchMap(term =>
  //       this.lookupSvc.typeaheadSearch(term, ['weaponmodel']).pipe(
  //         map((r: TypeaheadResults) => r.matches[0].hits['weapon']),
  //         catchError((e) => this.typeaheadFailure(e, 'Weapon'))
  //       ))
  //   )

  /** Handles confirmation dialog for deleting the entire image record and associated image files.
   * If the user types the word 'delete' and presses the affirmative button, the delete action is called on the Image Service.*/
  deleteImageRecord(): void {
    if (this.imageData.hasBoundPages) { // if the imagedata is part of a set
      // then open ok-only modal dialogue.
      const okBtn = new StarbaseModalButton('Okay', () => {
        this.modalSvc.closeModal('User pressed okay');
      });
      this.okModal = new StarbaseModalOptions(
        'Deletion Prohibited',
        'You cannot delete an image that is part of a bound set.', [okBtn], StarbaseModalTypes.Warning);
      this.modalSvc.postModal(this.okModal);
    } else { // else if imageData is not in a bound image set(ie imageData.boundImageSets.length === 0)
      const yesBtn = new StarbaseModalButton('Yes, delete forever', () => {
        if (this.delConfirmTxt?.nativeElement.value === 'delete') {
          this.delModal.working = true;
          yesBtn.name = 'Please wait...';
          this.deleteSubscriber = this.imgSvc.deleteData(this.imgSvc.deleteUri, this.imageData.uid.toString()).subscribe(d => {
            this.modalSvc.closeModal('User pressed delete.');
            this.notiSvc.postNotification(
              this.notiSvc.notificationBuilder(
                'Deleted successfully',
                'The record and image have been removed from the server.', undefined, undefined, StarbaseNotificationSentiment.Success));
            this.router.navigateByUrl('/library');
          }, err => {
            this.notiSvc.postNotification(
              this.notiSvc.notificationBuilder(
                'Deletion failed',
                err['friendly'], undefined, undefined, StarbaseNotificationSentiment.Error));
            console.error(err);
            this.delModal.working = false; yesBtn.name = 'Yes, delete forever';
          });
          this.subscriptionList.push(this.deleteSubscriber);
        } else {
          this.modalSvc.closeModal('User pressed delete, but did not confirm deletion phrase.');
          this.notiSvc.postNotification(
            this.notiSvc.notificationBuilder(
              'Deletion canceled',
              'The deletion keyword was not entered.', undefined, undefined, StarbaseNotificationSentiment.Info));
        }
      });
      const noBtn = new StarbaseModalButton('Cancel', () => {
        this.modalSvc.closeModal('User pressed cancel');
      });
      this.delModal = new StarbaseModalOptions(
        'Confirm Deletion',
        '', [yesBtn, noBtn], StarbaseModalTypes.Warning, this.deleteConfirmModal);
      this.modalSvc.postModal(this.delModal);
    }
  }

  /** Enables the panZoom utility and starts viewing the image in full screen.
   * Enables an overlay component. */
  fullScreenImage() {
    this.zoomMode = true;
    this.overlaySvc.enableOverlay();
    setTimeout(() => { // provides time for the overlay animation to finish
      const panzoom = Panzoom(this.panZoomDiv?.nativeElement, {
        animate: true, // turn animation defaults on for the plugin
        increment: 0.2, // zoom in/out increments with the buttons (20%)
        rangeStep: 0.2,
        minScale: 0.33, // minimum zoom level is 33%, this must be the same as the 'min' setting on the input[range] slider
        maxScale: 10.0, // maximum zoom level is 1000%, this must be the same as the 'max' setting on the input[range] slider
        duration: 350, // animation speed
        panOnlyWhenZoomed: false,
        easing: 'ease-in-out', // animation mode
        contain: false, // whether the image can pan outside of its parent div
        linearZoom: true,
        startScale: 1.1 // original scale of the image when entering zoom mode
      });
      this.zoomOutBtn?.nativeElement.addEventListener('click', () => {
        panzoom.zoomOut();
        this.currentZoomLevel = panzoom.getScale();
      });
      this.zoomInBtn?.nativeElement.addEventListener('click', () => {
        panzoom.zoomIn();
        this.currentZoomLevel = panzoom.getScale();
      });
      this.panZoomDiv?.nativeElement.addEventListener('wheel', (event: any) => {
        panzoom.zoomWithWheel(event);
        this.currentZoomLevel = panzoom.getScale();
      });
      this.zoomResetBtn?.nativeElement.addEventListener('click', () => {
        panzoom.reset();
        this.currentZoomLevel = panzoom.getScale();
        this.resetImageTransforms();
      });
      this.zoomRange?.nativeElement.addEventListener('input', (e) =>
        panzoom.zoom(e.target.valueAsNumber, { animate: false }));
    }, 1000);
    return false;
  }

  errorImageSpoof(): void {
    this.notiSvc.postNotification(
      this.notiSvc.notificationBuilder('Image Not Found',
        'Sorry, we couldn\'t load that image at this time. Please try again later.',
        undefined,
        undefined,
        StarbaseNotificationSentiment.Error)
    );
    setTimeout(() => this.zoomOutBtn?.nativeElement.click(), 1001);
  }
  /** Disables the panZoom utility and exits the full screen image viewing mode.
   * Disables an overlay component. */
  exitZoom(): void {
    this.zoomMode = false;
    this.overlaySvc.disableOverlay();
    this.singleImageViewWrapper?.nativeElement.focus();

    this.currentZoomLevel = 1.1; 
    this.resetImageTransforms();

    if (this.editMode) {
      setTimeout(() => this.setFormDirty(), 1); // in case the user had changes pending already
    }
  }
  rotateImage(angle: number): void {
    this.rotationAngle = (this.rotationAngle + angle) % 360;
  }

  resetRotation(): void {
    this.rotationAngle = 0;
  }

  toggleHorizontalFlip(): void {
    this.isFlippedHorizontally = !this.isFlippedHorizontally;
  }

  toggleVerticalFlip(): void {
    this.isFlippedVertically = !this.isFlippedVertically;
  }

  resetImageTransforms(): void {
    this.rotationAngle = 0;
    this.isFlippedHorizontally = false;
    this.isFlippedVertically = false;
  }

  getImageTransform(): string {
    const transforms = [];
    
    if (this.rotationAngle !== 0) {
      transforms.push(`rotate(${this.rotationAngle}deg)`);
    }
    
    const scaleX = this.isFlippedHorizontally ? -1 : 1;
    const scaleY = this.isFlippedVertically ? -1 : 1;
    if (scaleX !== 1 || scaleY !== 1) {
      transforms.push(`scale(${scaleX}, ${scaleY})`);
    }
    
    return transforms.length > 0 ? transforms.join(' ') : 'none';
  }

  @HostListener('document:keydown.escape', ['$event'])
  onEscapeKeydown(event: KeyboardEvent) {
    if (this.zoomMode) {
      this.exitZoom();
    }
  }

  /** Transforms the RowModel data to a WeaponLinking object.
   * Stores the resulting WeaponLinking object to the imageData.weapons property.
   *
   * @param row The object describing the altered WeaponLinking.
   */
  commitWeaponLinkChanges(row: IRowModel): void {
    const weaponsArr = [...this.imageData.weapons];
    const splicedArr = weaponsArr.filter(obj =>
      // eslint-disable-next-line eqeqeq
       obj != row
    );
    const arr = splicedArr.map(w => ({ weapon_Category: w.weapon_Category, secondaryWeapon: w.secondaryWeapon }));
    const r = { weapon_Category: row.weapon_Category, secondaryWeapon: row.secondaryWeapon };
    const bool = checkForDuplicateDataItems(arr, r);
    if (bool === true) {
      row.editMode = true;
      this.badDataEntered('Could not add duplicate weapon.');
      this.imageData.weapons = this.imageData.weapons.filter(w => {
        // eslint-disable-next-line eqeqeq
        if (w != row) {
          return w;
        }
      });
    } else if (bool === false) {
      this.imageData.weapons = weaponsArr;
    }
    if (!row.secondaryWeapon || !row.weapon_Category) {
      row.editMode = true;
      this.notiSvc.postNotification(
        this.notiSvc.notificationBuilder(
          'Error',
          `To add a weapon to this record, 
          please select both a weapon category and a corresponding weapon.`, undefined, 4000, StarbaseNotificationSentiment.Error));
      const i = this.imageData.weapons.findIndex(w => w === row);
      this.imageData.weapons.splice(i, 1);
      return;
    }
    this.getWeapons();
    let weapons = null;
    this.lookupSvc.getAllRequisiteData<Weapon>(this.lookupSvc.getWeaponsUrl).subscribe(w => {
      weapons = w;
      weapons.forEach(weapon => { // for each weapon
        // if the weapon and the weapon category are the same
        if (row.secondaryWeapon === weapon.secondaryWeapon && row.weapon_Category === weapon.primaryWeapon.weapon_Category) {
          row = this.filterDropdownData(row, this.weaponsColumnData);
          this.imageData.weapons.map(i => { // for each weapon
            if (i.weaponModelId === row.weaponModelId) {
              i.editMode = row.editMode;
              i.editable = row.editable;
              i.primaryWeapon = row.weapon_Category;
              i.weapon = weapon;
              i.secondaryWeapon = null;
              i.weapon.primaryWeapon = i.primaryWeapon;
              i.weaponModelId = i.weapon.uid;
              i.weapon.primaryWeaponUID = i.primaryWeapon.uid;
              i.weapon_Category = i.primaryWeapon.weapon_Category;
              i.secondaryWeapon = i.weapon.secondaryWeapon;
              this.setFormDirty();
            }
          });
        }
      });
    });
  }

  /** Handles New Entity Mode triggers on the Table-Editor instances.
   *
   * @param obj pass in an object with properties 'key' and optionally 'row' (as IRowModel)
   * where the 'key' is used to determine which NewEntity Mode we will enter.
   *  The 'row' property will be used to save a backup of the row data in case the user cancels.
   * @param priWeapon Optional. Passed in to identify if a new primary weapon is being added
   * @param secWeapon Optional. Passed in to identify if a new secondary weapon is being added
   */
  handleNewEntity(obj: { key: string; row?: IRowModel }, priWeapon?: PrimaryWeapon, secWeapon?: SecondaryWeapon) { // kmm comment
    switch (obj.key) {
      case 'secondaryWeapon':
        this.newEntityWeaponBackup = obj.row;
        this.weaponsTableRows = [new RowModel()];
        this.weaponsTableRows[0].uid = 0;
        this.weaponsTableRows[0].editMode = true;
        this.weaponsTableRows[0].weapon_Category = priWeapon ? priWeapon.weapon_Category : null;
        this.weaponsTableRows[0].secondaryWeapon = secWeapon ? secWeapon : null;
        this.newWeaponMode = true;
        break;
      case 'army':
        this.newArmyRowData = [new RowModel()];
        this.newArmyRowData[0].uid = 0;
        this.newArmyRowData[0].editMode = true;
        this.newArmyMode = true;
        break;
      case 'unit':
        this.newUnitRowData = [new RowModel()];
        this.newUnitRowData[0].uid = 0;
        this.newUnitRowData[0].editMode = true;
        this.newUnitMode = true;
        break;
      case 'regiment':
        this.regimentTableRows = [new RowModel()];
        this.regimentTableRows[0].uid = 0;
        this.regimentTableRows[0].editMode = true;
        this.newRegimentMode = true;
        break;
      case 'branch':
        this.branchTableRows = [new RowModel()];
        this.branchTableRows[0].uid = 0;
        this.branchTableRows[0].editMode = true;
        this.newBranchMode = true;
        break;
      case 'primaryWeapon':
        this.newEntityBackup = obj.row;
        this.newWeaponCatSequence = this.newWeaponMode;
        this.newWeaponMode = false;
        this.primaryWeaponsTableRows = [new RowModel()];
        this.primaryWeaponsTableRows[0].uid = 0;
        this.primaryWeaponsTableRows[0].editMode = true;
        this.newWeaponCatMode = true;
        break;
      case 'rank':
        this.newRankTableRows = [new RowModel()];
        this.newRankTableRows[0].uid = 0;
        this.newRankTableRows[0].editMode = true;
        this.newRankMode = true;
        break;
      case 'rankCat':
        this.newRankCatTableRows = [new RowModel()];
        this.newRankCatTableRows[0].uid = 0;
        this.newRankCatTableRows[0].editMode = true;
        this.newRankCatMode = true;
        break;
      case 'source':
        this.newLUSourceTableRows = [new RowModel()];
        this.newLUSourceTableRows[0].uid = 0;
        this.newLUSourceTableRows[0].editMode = true;
        this.newSourceMode = true;
        break;
    }
  }

  enableUpdateModal(msg: string, confirmmsg?: string): Observable<boolean> {
    const m = new Observable<boolean>(obj => {
        const modal = new StarbaseModalOptions('Image Updated', msg, [
            new StarbaseModalButton('Continue', () => {
                obj.next(true);
                this.modalSvc.closeModal(confirmmsg);
            })
        ], StarbaseModalTypes.Warning);
        modal.dismissable = true;
        this.modalSvc.postModal(modal);
    });

    return m;
  }

  handleSelectThumbnail(e) {
    console.log(e);
  }


  qmSearchError(err): void {
    console.error(err);
    this.appInsights.logError(err, { 'Quartermaster Spec Search error': 'Single Image record ' + this.imageData.uid });
  }

  battleSearchError(err): void {
    console.error(err);
    this.appInsights.logError(err, { 'Battle Search Error': 'Single Image record ' + this.imageData.uid});
  }

  /* ....END TYPEAHEAD SECTION.... */

  handleTableEditorOnChange(e: boolean) { // kmm comment
    if (e === true) { //
      this.imageData.weapons.forEach(w => { // for each weapon
        if (w.uid !== 0 && w.editMode) { // if the weapon is not new and the row is editable
          this.handleFilterWeapons(w);
        }
      });
    }
  }

  /** Accepts a list of LU_Sources data.
   * Sorts the resulting data alphabetically by 'source' property.
   * Stores the data in luSources.
   * Maps the data to an IColumnData[] and stores it in luSourcesData.
   *
   * @param s The LUSource[] data to store/setup.
   */
  setupSources(s: LUSource[]): void {
    this.luSources = AlphaSortArrayByProperty(s, 'source');
    this.luSourceData = LUSource.CreateLUSourceColumnData();
  }

  /** Accepts a list of Army data.
   * Sorts the data alphabetically by 'armyName' property.
   * Stores the data in armyData.
   *
   * @param a The Army[] to be stored/setup.
   */
  setupArmies(a: Army[]): void {
      this.armyData = a;
      Army.setupArmyCollection(this.armyData); // setup army data to be displayed
  }

  /** Accepts a list of LUArmy data and
   * sorts the data alphabetically by 'armyName'
   * before storing it to luArmyData.
   * Maps the data to an IColumnData[] and stores it in armyColumnData.
   *
   * @param l The LUArmy[] to be stored/setup.
   */
  setupLUArmies(l: LUArmy[]): void {
    this.luArmyData = AlphaSortArrayByProperty(l, 'armyName'); // sort data
      this.armyColumnData = Army.CreateArmyColumnData(this.luArmyData); // setup army column data
  }

  /** Accepts a list of Battle data.
   * Maps the data to an IColumnData[] and stores it in battleColumnData.
   *
   * @param b The Battle[] to be stored/setup
   */
  setupBattles(b: Battle[]): void {
    this.battleData = AlphaSortArrayByProperty(b, 'name');
    this.battleColumnData = BattleSelect.BattleSelectColumnData(b, true);
  }

  /** Handles Army value changes and deals with 'null', null, and -1.
   * Called by Army select interaction on the template.
   *
   * @param value the data describing the Army option chosen. */
  checkNullArmy(value: any): void {
    if (value === null || value === 'null') {
      this.imageData.army = null;
      this.imageData.armyId = null;
      // eslint-disable-next-line eqeqeq
    } else if (value == -1) {
      this.handleNewEntity({ key: 'army' });
      this.imageData.armyId = null;
      this.imageData.army = null;
    } else {
      this.imageData.armyId = value;
      this.imageData.army = this.armyData.find(a => a.uid === value);
    }
  }

  /** Handles Source value changes and deals with 'null', null, and -1.
   * Called by Source select dropdown interaction on the template.
   *
   * @link LUSource
   * @param source the data describing the Source option chosen.
   */
  checkNullSource(source: any): void {
    if (source === null || source === 'null') {
      this.imageData.sourceId = null;
      this.imageData.source = null;
      // eslint-disable-next-line eqeqeq
    } else if (source == -1) {
      this.handleNewEntity({ key: 'source' });
      this.imageData.sourceId = null;
      this.imageData.source = null;
    } else {
      this.imageData.sourceId = source;
      this.imageData.source = this.luSources.find(s => s.uid === source);
    }
  }

  /** Handles LocationState value changes and deals with 'null', null, and undefined.
   * Called by LocationState select dropdown interaction on the template.
   *
   * @param value the data describing the LocationState option chosen.
   */
  changeLocationState(value: any): void {
    if (value === '' || value === 'null' || value === null || value === undefined || value === 'No state chosen') {
      this.imageData.locationState = null;
      this.imageData.locationStateId = null;
    } else {
      this.imageData.locationStateId = value;
      this.imageData.locationState = this.statesData.find(s => s.uid === value);
    }
  }

  /** Accepts a list of US States data.
   * Sorts the data alphabetically by 'state_Name' property.
   * Stores the data in statesData.
   *
   * @param s The State[] data to be stored.
   */
  setupStates(s: State[]): void {
    this.statesData = AlphaSortArrayByProperty(s, 'state_Name');
  }

  /** Retrieves the data needed to assemble a UnitLink from the Lookup Service.
   * Uses the data to create an IColumnData[] for UnitLinks.
   *
   * @type UnitLinking
   */
  getUnits(): void {
    try {
      forkJoin(
        [this.lookupSvc.getAllRequisiteData<Regiment>(this.lookupSvc.getRegimentNosUrl).pipe(map(regs => this.regiments = regs)),
        of(this.statesData).pipe(map(states => states)),
          this.lookupSvc.getAllRequisiteData<BranchOfService>(
            this.lookupSvc.getBranchesUrl).pipe(
              map(branches => this.branchesOfService = branches)),
        this.lookupSvc.getAllCompanyLetters().pipe(map(s => this.companyLetters = s))] // get all company letters
      ).pipe(defaultIfEmpty([[],[],[],[]]),
        map(([regs, states, branches, coLetters]: [Regiment[], State[], BranchOfService[], string[]]) => {
          const corps: {'corps': number}[] = [];
          this.lookupSvc.getAllCorps().subscribe(d => corps.push({ corps: d }));
        this.unitLinksColumnData = UnitLinking.unitLinkingColumnData(regs, states, branches, corps);
      })).subscribe(
        () => {
          this.setupUnitData();
        },
        e => {
 throw e;
}
      );

    } catch (ex) {
      this.errorMessage += ' Unit Data could not be loaded.';
      console.error('Error when loading Units data: ', ex);
    }
  }


  /** Retrieves weaponCategory, weapons, and assembles WeaponLinking objects.
   * Uses a custom ColumnModel configuration for the table-editor.
   */
  getWeapons(): void {
    this.weaponsSubscriber = this.lookupSvc.getAllRequisiteData<PrimaryWeapon>(this.lookupSvc.getPrimaryWeaponsUrl).subscribe(d => {
      this.priWeaponsData = d; // set primary weapons data to a variable
      this.newWeaponCols = [
        new ColumnModel(
          'Weapon Category', 'primaryWeapon', 'PrimaryWeapon', true, 'dropdown', false, false, 30, false, d, 'weapon_Category'),
        new ColumnModel('Weapon', 'secondaryWeapon', 'SecondaryWeapon', true, 'string', false, false, 30, true),
      ]; // define columns(different than the definition from those in the Weapons file because they only have two columns)
      this.lookupSvc.getAllRequisiteData<Weapon>(this.lookupSvc.getWeaponsUrl).subscribe(e => { // for each weapon
        // if creating a new weapon directly (NOT if creating a new weapon category simultaneously)
        if (this.newWeaponMode && this.newWeaponCatSequence === false) {
          this.weaponsData = e;
          this.handleNewWeaponMode();
        } else if (this.newWeaponCatSequence === true) { // if creating a new weapon category while creating a new weapon
          let newWeaponCat = this.priWeaponsData[0];
          this.priWeaponsData.forEach(w => {
            if (w.uid > newWeaponCat.uid) {
              newWeaponCat = w;
            }
          });
          this.handleNewEntity({key: 'secondaryWeapon', row: this.newEntityBackup }, newWeaponCat, this.newEntityBackup.secondaryWeapon);
        } else if (this.newWeaponCatMode) {
          this.handleNewWeaponCatMode();
          this.newWeaponCatSequence = false;
        }
        this.weaponsColumnData = WeaponLinking.WeaponLinkColumnData(this.priWeaponsData, e);
        this.weaponsRows = e;
        Weapon.setupWeaponCollection(this.weaponsData);
      });
    });
    this.subscriptionList.push(this.weaponsSubscriber);
  }

  /** Loads the other image records in the bound set for the currently loaded record.
   * Stores data for the Table-editor and the carousel components.
   */
  getBoundImageSetForThisImage() {
    this.lookupSvc.getBoundImagesSetByNameFromServer(this.imageData.boundSetName).subscribe(a => {
      const arr = [];
      a.forEach(item => {
        arr.push(item.imageModel);
      });
      this.imageModels = arr;
      if (this.boundImages) {
        this.boundImages.imageModels = this.imageModels; // To make sure the image set changes properly sometimes it must be manually set.
        this.boundImages.initializeCarousel();
      }
    });
    this.lookupSvc.getAllBoundImagesSetByNameFromServer(this.imageData.boundSetName).subscribe(a => {
      this.boundImageSetTableRows = a;
      this.boundImageSetsCols[0] = new ColumnModel('Image Name', 'imageName', 'imageName', false, 'string', false, false, 150, false);
      this.boundImageSetTableRows.forEach(row => {
        row['imageName'] = row.imageModel.name;
      });
    });
  }

  getBoundImageSetNextPage() {
    if (!this.loadingNextPage) {
      this.loadingNextPage = true;
      this.lookupSvc.getBoundImagesSetByNameFromServer(this.imageData.boundSetName, ++this.boundSetImagesPage).subscribe(a => {
        a.forEach(item => {
          this.imageModels.push(item.imageModel);
        });
        this.loadingNextPage = false;
      });
    }
  }

  /** Call this function when loading an image record that has no Bound Image Sets. */
  clearBoundImageSetForThisImage() {
    this.boundImageSetTableRows = [];
    this.imageModels = [];
    if (this.boundImages) {
      this.boundImages.imageModels = this.imageModels; // To make sure the image set changes properly somtimes it must be manually set.
      this.boundImages.initializeCarousel();
    }
  }

  /** Deals with moving the table-editor to "New Entity Mode"
   * and applying data transforms for this purpose
   * for creating a new Weapon Category.
   */
  handleNewWeaponCatMode() { // kmm comment
    let newWeaponCat = this.priWeaponsData[0]; // assign newWeaponCat to the first item in the primary weapons array
    this.priWeaponsData.forEach(w => { // for each weapon category
      if (w.uid > newWeaponCat.uid) {
        newWeaponCat = w; // reassign newWeaponCat to the current weapon category
      }
    });
    this.imageData.weapons.forEach(w => { // for each weapon
      if (w.editMode) { // if the currentWeapon is in editMode
        w.primaryWeapon = newWeaponCat;
        w.secondaryWeapon = null;
        w.weapon = null;
        w.weaponModelId = null;
        w.weapon_Category = newWeaponCat.weapon_Category;
        w.weaponModelId = w.primaryWeapon.uid; // map values from the current weapon to avoid [object object] values
        this.newWeaponCatMode = false; // toggle new entity mode off
      }
    });
  }

  /** Deals with moving the table-editor to "New Entry Mode"
   * and applying data transforms for this purpose
   * for creating a new Weapon.
   */
  handleNewWeaponMode() { // kmm comment
    let newWeapon = this.weaponsData[0]; // assign the first item in the weaponsData array to a variable
    this.weaponsData.forEach(w => { // for each weapon
      if (w.uid > newWeapon.uid) { // if the weapon is not a new weapon
        newWeapon = w;
      }
    });
    this.imageData.weapons.map(w => { // for each weapon
      if (w.editMode) {
        w.secondaryWeapon = newWeapon.secondaryWeapon;
        w.primaryWeapon = newWeapon.primaryWeapon;
        w.weapon = newWeapon;
        w.weaponModelId = w.weapon.uid;
        w.editable = newWeapon.editable;
        w.imageModelId = this.imageData.uid;
        w.weapon_Category = w.primaryWeapon.weapon_Category; // Mapping data to avoid [object object] values
        this.newWeaponMode = false; // exit newWeaponMode
        w = w as WeaponLinking;
        w.editMode = false;
        this.setFormDirty();
      }
    });
  }

  /** Filters the weapons dropdown data based on
   * the weapon Category passed in.
   *
   * @param e the weapon category on which to filter weapon data.
   */
  handleFilterWeapons(e) {
    let uid = null;
    this.priWeaponsData.forEach(pw => { // filter through primary weapons
      if (e.weapon_Category.weapon_Category === pw.weapon_Category) { // passed in weapon category matches current weapon category
        uid = pw.uid;
      }
    });
    const arr = [];
    this.weaponsRows.forEach(w => { // for each weapon
      if (uid === w.primaryWeaponUID) { // if uid(from above) matches weapons id,
        arr.push(w); // add that weapon to the array
      }
    });
    this.filterNotifier.valueChanged(arr); // emit the arr to the filter notifier
  }

  /** Accepts Rank data
   * and initializes the collection of data as Rank objects.
   * Stores the data in ranksData.
   *
   * @param r the Rank[] to be stored and setup.
   */
  setupRanks(r: Rank[]): void {

    this.ranksData = r; // refresh ranks data
    Rank.setupRankCollection(this.ranksData); // initialize the ranks array

  }

  /** Accepts RankCategory data
   * and initializes the collection of data as RankCategory objects.
   * Stores the data in rankCatsData.
   *
   * @param r RankCategory[] to be stored and setup.
   */
  setupRankCats(r: RankCategory[]): void {

      this.rankCatsData = r; // save rankCats data
      this.rankColumnData = Rank.CreateRankColumnData(this.rankCatsData); // get RankColumn columns
      this.rankCatColumnData = RankCategory.CreateRankCategoryColumnData(); // getRankCat columns

  }

  /** Transforms the RowModel data to an Army object.
   * Saves the resulting Army object to the Lookup Service.
   *
   * @param row The RowModel describing the new Army. */
  commitNewArmy(row: RowModel): void {
    const r = new Army(); // create a new instance of army
    this.luArmyData.forEach(army => { // for each army
      if (row.armyName === army.armyName) { // if row's armyName equals curr army armyname
        r.armyId = army.uid; // reassign curr army uid
        r.uid = 0; // set uid to 0
        r.regionalName = row.regionalName; // reassign regionalName
        this.lookupSvc.postRequisiteData<Army>(this.lookupSvc.postArmyUrl, r).subscribe(() => {
          this.newArmyMode = false; // set newArmyMode to false
          this.lookupSvc.getAllRequisiteData<Army>(
            this.lookupSvc.getArmiesUrl).pipe(tap(armies => this.setupArmies(armies))).subscribe(); // refresh army data
        });
      }
    });
  }

  /** Retrieves all Related Image Sets for the current image.
   * Stores the resulting data in recordSets. */
  getRecordSets(id: number): void {
    this.recordSetsSubscriber = this.lookupSvc.getExistingRelatedImageSetsForOneImage(id).subscribe(s => {
      this.recordSets = s;
      this.sequenceNumberCols = RelatedSetLinkingModel.sequenceNumberColumnData();
      this.sequenceNumberRows = s;
    });
    this.subscriptionList.push(this.recordSetsSubscriber);
  }

  getRelatedImageSetData(id: number) {
    if (id == undefined) {
      return;
    }
    this.relevantRSVSubscriber = this.imgSvc.getAllRelatedImageSetData(id).subscribe(
      (res: RelatedImageSetViewDataModel[]) => { 
        this.relevantRelatedImageSetsForCurrentRecord = res;
      }
    );
    
    this.subscriptionList.push(this.relevantRSVSubscriber);
  }
  /** Transforms the RowModel data to a LUSource object.
   * Saves the resulting LUSource object to the Lookup Service.
   *
   * @param row The RowModel describing the new Source.
   * @link LUSource  */
  commitNewSource(row): void {
    row.uid = 0; // set uid 0
    this.lookupSvc.postRequisiteData<LUSource>(this.lookupSvc.postLUSourceUrl, row).subscribe(() => { // save row to server
      this.newSourceMode = false; // set newSourceMode to false
      this.lookupSvc.getAllRequisiteData<LUSource>(
        this.lookupSvc.getLUSourcesUrl).pipe(map(sources => this.setupSources(sources))).subscribe(); // refresh source data
    });
  }

  /** Transforms the RowModel data to a Weapon object.
   * Saves the resulting Weapon object to the Lookup Service.
   *
   * @param row The IRowModel describing the new Weapon.
   */
  commitNewWeapon(row: IRowModel): void {
    row = this.filterDropdownData(
      row, this.newWeaponCols, 'name'); // reassign the string at the name key to an object matching an item in the dropdown data array
    this.weaponsRowBackup = row;
    row.weapon_Category = row.primaryWeapon.weapon_Category;
    const w = new Weapon();
    w.primaryWeaponUID = row.primaryWeapon.uid; // reassign primaryWeaponUid to be an int instead of an object
    w.secondaryWeapon = row.secondaryWeapon; // reassign secondaryWeapon to the row's secondaryWeapon
    this.lookupSvc.postRequisiteData<Weapon>(this.lookupSvc.postWeaponUrl, w).subscribe(() => {
      this.getWeapons(); // refresh weapons data
      this.handleTableEditorOnChange(true);
      this.newWeaponCatSequence = false;
      this.newWeaponCatMode = false;
    }, e => {
      console.error(e);
      row.editMode = true;
      this.newWeaponMode = false;
      this.badDataEntered('This weapon already exists!');
    });
  }

  /** Transforms the RowModel data to a WeaponCategory object.
   * Saves the resulting WeaponCategory object to the Lookup Service.
   *
   * @param row The IRowModel describing the new WeaponCategory. */
  commitNewWeaponCat(row: IRowModel) {
    const wc = new PrimaryWeapon().deserialize(row);
    this.lookupSvc.postRequisiteData(this.lookupSvc.postPrimaryWeaponUrl, wc).subscribe(() => {
      this.getWeapons(); // refresh weapons data
      if (row.uid !== 0) { // if not a new row
        this.imageData.weapons = this.setupWeaponLinksData(this.imageData.weapons); // initialize weapon link data
      }
    }, e => {
      console.error(e);
      row.editMode = true;
      this.badDataEntered('This weapon category already exists!');
      this.newWeaponCatMode = false;
    });
  }

  /** Transforms the RowModel data to a Regiment object.
   * Saves the resulting Army object to the Lookup Service.
   *
   * @param row The RowModel describing the new Army. */
  commitNewRegiment(row: IRowModel) {
    const r = new Regiment(); // create new instance of regiment
    r.regimentNo = row.regimentNo; // reassign regimentNo
    this.lookupSvc.postRequisiteData<Regiment>(this.lookupSvc.postRegimentNoUrl, r).subscribe(() => {
      this.newRegimentMode = false;
      this.setupUnitData(); // initialize refreshed unit data
    }, e => {
      console.error(e);
      this.newRegimentMode = false;
      this.setupUnitData(); // initialize refreshed unit data
    });
  }

  /** Transforms the RowModel data to a BranchOfService object.
   * Saves the resulting BranchOfService object to the Lookup Service.
   *
   * @param row The IRowModel describing the new Branch.
   */
  commitNewBranch(row: IRowModel) {
    const b = new BranchOfService(); // create new instance of branch
    b.branchName = row.branchName;
    this.lookupSvc.postRequisiteData<BranchOfService>(this.lookupSvc.postBranchUrl, b).subscribe(() => {
      this.newBranchMode = false;
      this.setupUnitData(); // initialize unit data
    }, e => {
      console.error(e);
      this.newBranchMode = false;
      this.setupUnitData(); // initialize unit data
    });
  }

  /** Transforms the RowModel data to a Rank object.
   * Saves the resulting Rank object to the Lookup Service.
   *
   * @param row The IRowModel describing the new Rank. */
  commitNewRank(row: IRowModel) {
    const r = new Rank(); // create new instance of a rank
    r.rankName = row.rankName;
    r.rankCategoryId = row.rankCategoryName.uid;
    this.lookupSvc.postRequisiteData<Rank>(this.lookupSvc.postRankUrl, r).subscribe(
      () => { },
      e => console.error(e),
      () => {
        this.newRankMode = false;
        this.lookupSvc.getAllRequisiteData<Rank>(
          this.lookupSvc.getRanksUrl).pipe(map(ranks => this.setupRanks(ranks))).subscribe(); // refresh rank data
    });
  }

  /** Transforms the RowModel data to a RankCategory object.
   * Saves the resulting RankCategory object to the Lookup Service.
   *
   * @param row The IRowModel describing the new RankCategory. */
  commitNewRankCat(row: IRowModel) {
    const rc = new RankCategory().deserialize(row); // setup rank category row
    this.lookupSvc.postRequisiteData<RankCategory>(this.lookupSvc.postRankCatUrl, rc).subscribe(
      () => { },
      e => console.error(e),
      () => {
      this.newRankCatMode = false;
        forkJoin([
          this.lookupSvc.getAllRequisiteData<Rank>(this.lookupSvc.getRanksUrl).pipe(map(ranks => this.setupRanks(ranks))).subscribe(),
          this.lookupSvc.getAllRequisiteData<RankCategory>(
            this.lookupSvc.getRankCatsUrl).pipe(map(rankCats => this.setupRankCats(rankCats)))
        ]).subscribe(); // refresh rank/rankCat data
    });
  }

  /** Generic utility to convert from type T as an array
   * to an array of IRowModels.
   *
   * @type T as object.
   * @param source array of type T objects that will be mapped to IRowModel[].
   * @returns Observable of an array of IRowModels mapped from the source. */
  setupRowData<T extends object>(source: T[]): Observable<IRowModel[]> {
    // eslint-disable-next-line @typescript-eslint/no-shadow
    if (!source) {
      return of([]);
    }
    if (source.length === 0) {
      return of([]);
    }
    return of(source).pipe(
      map(i => i.map(
        (k: T) => {
          const r: IRowModel = new RowModel();
          r.uid = null; // will be overwritten by the spread if UID is present
          r.editMode = false;
          r.editable = true;
          return { ...r, ...(k as object) };
        }
      ))
    );
  }

  /** Loads, deserializes and sets up all needed properties for the imageData.relevantDates data. */
  setupDatesData(d: ImageDate[]): ImageDate[] {
    if (!d || !d.length) {
      this.datesTableRows = [];
      console.log('No dates data for this record');
      return [];
    }
    d.forEach((a, b, c) => c[b] = new ImageDate(a.month).deserialize(a)); // allow for constructor setup of longMonthString prop
    this.setupRowData<ImageDate>(d).subscribe(dd => this.datesTableRows = dd);
    return d;
  }

  /** Transforms the RowModel data to an ImageDate object.
   * Checks for invalid data and prevents saving if incorrect.
   * Checks for duplicates before proceeding.
   * Saves the resulting ImageDate object to the Lookup Service.
   *
   * @param row The RowModel describing the new ImageDate. */
  commitDateChanges(row: IRowModel): void { // kmm comment
    // TODO: allows dupes if both rows are new, but shouldn't
    const monthNo = ImageDate.convertToMonthNumber(row.longMonthString);
    row.month = monthNo === -1 ? 0 : monthNo;
    if (row.year === undefined) {
 row.year = 0;
}
    if (row.day === undefined) {
 row.day = 0;
}
    if (row.quarter === undefined) {
 row.quarter = 0;
}
    if (row.year > 3000 || row.year < 0 || isNaN(row.year)) {
      this.badDataEntered('Please enter a valid year (between 0 and 3000).');
      return;
    } else if (row.day > 31 || row.day < 0 || isNaN(row.day)) {
      this.badDataEntered('Please enter a valid day of the month (0 for unknown).');
      return;
    } else if (row.quarter < 0 || row.quarter > 4 || isNaN(row.quarter)) {
      this.badDataEntered('Please enter a valid value for quarter (between 1 and 4; 0 for unknown).');
      return;
    }

    const datesArr = [...this.imageData.relevantDates];
    const arr = datesArr.slice(0, datesArr.length).map(u => ({
      day: u.day,
      longMonthString: u.longMonthString,
      year: u.year,
      month: u.month,
      quarter: u.quarter !== 0 ? u.quarter : ImageDate.findQtrValue(u.month)
      }));

    const r = {
      day: parseInt(row.day, 10),
      longMonthString: row.longMonthString || '',
      year: parseInt(row.year, 10),
      month: row.month, quarter: ImageDate.findQtrValue(row.month)
    };
    const bool = checkForDuplicateDataItems(arr, r);
    if (bool === true) {
      this.badDataEntered('Duplicate date value entered.');
      console.warn('Duplicate date detected. Removing newest entry.');
      return;
    } else {
      if (row.uid === 0) {
        if (this.imageData.typeOfImageId === ImageTypes['General/Special_Orders'] && this.imageData.relevantDates.length > 0) {
          this.datesTableRows.splice(this.datesTableRows.indexOf(row), 1);
          this.badDataEntered('General/Special Orders may have only one issue date.');
          return;
        }
        row.imageUID = this.imageData.uid;
        const date: ImageDate = new ImageDate(row.month).deserialize(row);
        if (date.month > 0) {
 date.quarter = date.autoFillQtr(date.month); row.quarter = date.quarter;
}
        date.longMonthString = row.longMonthString;
        this.imageData.relevantDates.push(date);
      } else {
        const i = this.imageData.relevantDates.findIndex(j => j.uid === row.uid);
        const editRow: ImageDate = new ImageDate(row.month).deserialize(row);
        if (editRow.month > 0) {
 editRow.quarter = editRow.autoFillQtr(editRow.month); row.quarter = editRow.quarter;
}
        this.imageData.relevantDates[i] = editRow;
      }
      this.setFormDirty();
    }
  }

  /** Called by the "Back to Gallery" button.
   * Handles pre-processing before moving back to the Gallery view
   * by interacting with the GalleryType Service. */
  navigateToLibrary(): void {
    this.router.navigateByUrl('/library');
  }

  /** Called by the "Back to Qm Spec" button.
   * Handles navigating back to the QM Spec View.
   */
  navigateToQMSpec(): void {
    this.router.navigateByUrl('/quartermaster-manuals/' + this.qmID);
  }

  /** Handles removal request for a RowModel containing an ImageDate object.
   * Builds a modal dialog for confirmation before proceeding.
   * If the user confirms, passes control to the Lookup Service.
   *
   * @param row The IRowModel object describing the ImageDate to be deleted.
   */
  commitDateRemoval(row: IRowModel): void {
    if (row.uid === 0) {
      return; // if the row is new, return
    }
    const yesBtnCb = () => {
      this.lookupSvc.deleteData(this.lookupSvc.deleteImageDateUrl, row.uid.toString()).subscribe(() => {
        this.datesNotifier.valueChanged(row.uid); // emit uid of row where date was removed
        // display all rows besides the deleted row
        this.imageData.relevantDates = this.imageData.relevantDates.filter(a => a.uid !== row.uid);
      }, e => {
        this.notiSvc.postNotification(
          this.notiSvc.notificationBuilder(
            'Deletion failed',
            'Could not remove the date from this record. ' + e['friendly'],
            undefined, undefined, StarbaseNotificationSentiment.Error)); // post error
      });
    };
    const noBtnCb = () => {
      this.getDatesData(this.imageData.uid, 1).subscribe(d => this.setupDatesData(d)); // setup dates data
    };
    this.handleDeleteSubtableRecord(
      'Date', row.longMonthString + ' ' + row.day + ', ' + row.year, yesBtnCb, noBtnCb); // delete subtable record
    this.setFormDirty();
  }

  /** Removes date row if its cancelled */
  removeNewDateRow(row: IRowModel) {
    this.datesNotifier.valueChanged(row); // emit the row where the date was removed
    const arr = [];
    this.imageData.relevantDates.forEach(d => {
      // if curr date is not new and matches the passed in row's date
      if (!(d.uid === 0 && parseInt(row.day, 10) === d.day && row.month === d.month && parseInt(row.year, 10) === d.year)) {
        arr.push(d); // add curr date to the array
      }
    });
    this.imageData.relevantDates = arr; // reassign relevantDates to the filteredArr
  }

  /** Called by event emitted on the Quartermaster Manual Autocomplete search*/
  addBattleToImageFile(battle: Battle) {

    if (!this.imageData.quarterMasterManuals) {
      this.imageData.quarterMasterManuals = [];
    }
    // WE FIRST FIND FOR REPEATS
    const el = this.imageData.battleLinks.find(x => x.battleUID === battle.uid && x.imageUID === this.imageData.uid);

    if (!el) {
      if (this.imageData.typeOfImageId !== ImageTypes['Letters & Diaries'] && this.imageData.battleLinks.length > 0) {
        this.badDataEntered('Record may have only one battle.');
        return;
      }
      const linkModel = new BattleLink();

      linkModel.battleUID = battle.uid;
      linkModel.battle = battle;
      linkModel.imageUID = this.imageData.uid;

      this.imageData.battleLinks.push(linkModel);
      this.setFormDirty();
    }
  }

  removeBattleLink(battle: Battle) {
      for (let i = 0; i < this.imageData.battleLinks.length; i++) {
          const item = this.imageData.battleLinks[i];

          if (item.imageUID === this.imageData.uid && item.battleUID === battle.uid) {
            this.imageData.battleLinks.splice(i, 1);
            this.setFormDirty();
            break;
          }
      }
  }

  /** Removes keyword row if its cancelled */
  removeNewKeywordRow(row: IRowModel) {
    this.keywordsNotifier.valueChanged(row); // emit row to the keywords component
    const arr = [];
    this.imageData.imageKeywords.forEach(k => { // for each keyword
      if (!(k.lU_Keyword.keyword === row.keyword)) { // if the row is not new and the keyword does not match the passed in keyword
        arr.push(k); // add the row to the array
      }
    });
    this.imageData.imageKeywords = arr; // reassign keywords to equal the empty array
  }

  /** Removes unit row if its cancelled */
  removeNewUnitRow(row: IRowModel) {
    this.unitsNotifier.valueChanged(row); // emit row
    const arr = [];
    this.imageData.units.forEach(u => { // for each unit
      // if curr unit matches
      if (!(u.uid === 0
        && row.branchName === u.branchName
        && u.companyLetters === row.companyLetters
        && u.regimentNoId === row.regimentNoId
        && row.state === u.state)) {
        arr.push(u); // push the curr unit to the array
      }
    });
    this.imageData.units = arr; // reassign units for the record to be the filtered array
  }

  /** Removes weapon row if its cancelled */
  removeNewWeaponRow(row: IRowModel) {
    const arr = [];
    this.imageData.weapons.forEach(w => { // for each weapon
      if (!(w.uid === 0
        && row.weapon_Category === w.weapon_Category
        && row.secondaryWeapon === w.secondaryWeapon)) { // if row is not new and weapon matches
        arr.push(w); // push weapon to array
      }
    });
    this.imageData.weapons = arr;
  }

  /** Starts the Individual Entry component in "Add" mode.
   * And initializes the new ImageIndividual object to be used.
   */
  addImageIndividual(): void {
    this.individualEditMode = false; // add mode
    this.individualData = new ImageIndividual();
    this.individualData.rank = new Rank();
    this.individualData.regimentNo = new Regiment();
    this.individualData.state = new State();
    this.individualData.branch = new BranchOfService();
    this.individualData.companyLetters = '';
    this.showIndividualEditor = true;
    this.setFormDirty();
  }

  /** Starts the Individual Entry component in "Edit" mode.
   * Initializes the ImageIndividual passed in object to be edited.
   *
   * @param ind The ImageIndividual object to be edtited in the editor component.
   */
  editIndividual(ind: ImageIndividual): void {
    this.individualEditMode = true;
    this.individualData = JSON.parse(JSON.stringify(ind)); // deref the obj
    // this.backupIndividual = JSON.parse(JSON.stringify(ind));
    this.showIndividualEditor = true;
    this.setFormDirty();
    /* if the record being edited is still 'new' (not yet saved to server),
    ** then remove it from the array of individuals so the modified version can be re - added. */
    if (ind.uid === 0) {
      const idx = this.imageData.imageIndividuals.findIndex(
        i => i.uid === 0
          && i.firstName === ind.firstName
          && i.lastName === ind.lastName);
      this.imageData.imageIndividuals.splice(idx, 1);
    }
  }
  /** Called by event emitter on the ImageIndividual Entry component when it is
   * done with ADD mode.
   * Handles pushing the data into the appropriate imageData property and cleanup.
   *
   * @param ind The ImageIndividual emitted from the Individual Entry component.
   */
  doneAddingIndividual(ind: ImageIndividual) {
    this.imageData.imageIndividuals.push(ind);
    this.showIndividualEditor = false;
    this.setFormDirty();
  }

  /** Called by event emmited on the Quartermaster Manual Autocomplete search*/
  addQmToImageFile(manual: QMManual) {

    if (!this.imageData.quarterMasterManuals) {
      this.imageData.quarterMasterManuals = [];
    }
    // WE FIRST FIND FOR REPEATS
    const el = this.imageData.quarterMasterManuals.find(x => x.qM_ManualModelUID === manual.uid && x.imageModelUID === this.imageData.uid);

    if (!el) {
      const linkModels = new QMManualLink();

      linkModels.qM_ManualModelUID = linkModels.qM_ManualModelUID = manual.uid;
      linkModels.qM_ManualModel  = manual;
      linkModels.imageModelUID = linkModels.imageModelUID = this.imageData.uid;
      linkModels.imageModel = null;
      linkModels['added_before_save'] = 1;

      this.imageData.quarterMasterManuals.push(linkModels);
      this.setFormDirty();
    }
  }

  removeQmLink(qmlink: QMManual) {
      for (let i = 0; i < this.imageData.quarterMasterManuals.length; i++) {
          const citem = this.imageData.quarterMasterManuals[i];

          if (citem.imageModelUID === this.imageData.uid && citem.qM_ManualModelUID === qmlink.uid) {
            this.imageData.quarterMasterManuals.splice(i, 1);
            this.qMLinks.splice(i, 1);
            this.setFormDirty();
            break;
          }
      }
  }

  /** Called by event emitter on the ImageIndividual Entry component when it is
   * done with EDIT mode.
   * Handles modifying the data in the appropriate imageData property and cleanup.
   *
   * @param ind The ImageIndividual emitted from the Individual Entry component.
   */
  doneEditingIndividual(ind: ImageIndividual) {
    if (ind.uid && ind.uid > 0) {
      const overwriteIdx = this.imageData.imageIndividuals.findIndex(i => i.uid === ind.uid);
      this.imageData.imageIndividuals[overwriteIdx] = ind;
    } else {
      this.imageData.imageIndividuals.push(ind);
    }
    this.showIndividualEditor = false;
    this.setFormDirty();
  }

  /** Called by event emitter on the ImageIndividual Entry component when it is
   * canceling actions. */
  cancelIndividualChanges() {
    this.showIndividualEditor = false;
    this.individualData = null;
  }

  /** Handles initialization of the collection of ImageIndividuals data and related data. */
  setupImageIndividuals(individuals: ImageIndividual[]): void {
    ImageIndividual.setupCollection(individuals);
    // Rank.setupRankCollection(this.ranksData);
  }


  /** Handles removal request for a RowModel containing an ImageIndividual object.
   * Builds a modal dialog for confirmation before proceeding.
   * If the user confirms, passes control to the Lookup Service.
   *
   * @param row The IRowModel object describing the ImageIndividual to be deleted.
   */
  commitImageIndividualRemoval(row: IRowModel): void {
    if (row.uid === 0) {
      return;
    }
    const yesBtnCb = () => {
      this.lookupSvc.deleteData(this.lookupSvc.deleteImageIndividualUrl, row.uid.toString()).subscribe(() => {
        this.imageData.imageIndividuals = this.imageData.imageIndividuals.filter(a => a.uid !== row.uid);
        this.showIndividualEditor = false;
      }, e => {
        this.notiSvc.postNotification(
          this.notiSvc.notificationBuilder(
            'Deletion failed',
            'Could not remove the individual from this record. ' + e['friendly'],
            undefined, undefined, StarbaseNotificationSentiment.Error));
      });
    };
    const noBtnCb = () => {
      this.setupImageIndividuals(this.imageData.imageIndividuals);
    };
    this.handleDeleteSubtableRecord('individual', row.firstName + ' ' + row.lastName, yesBtnCb, noBtnCb);
  }


  addKeywordToImage(keywordSelection: LU_Keyword): void {
    if (!keywordSelection) {
 return;
}
    if (this.imageData.imageKeywords.findIndex(k => k.lU_KeywordUID === keywordSelection.uid) > -1) {
      this.notiSvc.postNotification(
        this.notiSvc.notificationBuilder(
          'Cannot Add Keyword',
          'That keyword is already linked on this record.', undefined, 4000, StarbaseNotificationSentiment.Notice));
      return;
    }
    const newLink = new KeywordLinking();
    newLink.lU_KeywordUID = keywordSelection.uid;
    newLink.imageModelUID = this.imageData.uid;
    newLink.uid = 0;
    this.keywordSvc.addKeywordLink(newLink).subscribe(
      (link: KeywordLinking) => {
        this.notiSvc.postNotification(
          this.notiSvc.notificationBuilder(
            'Keyword Linked',
            `"${titleCaseString(keywordSelection.keyword)}" was added.`,
            undefined, undefined, StarbaseNotificationSentiment.Success
          )
        );
        this.imageData.imageKeywords.push(link);
        this.nextKeywordText = '';
        this.setFormDirty();
      },
      (e) => {
        console.error(e);
        this.notiSvc.postNotification(
          this.notiSvc.notificationBuilder(
            'Error',
            'Failed to link the keyword',
            undefined, undefined, StarbaseNotificationSentiment.Error
          )
        );
      }
    );
  }


  /** Logs invalid sequence number data and nothing else because there
   * are no explicit rules on this data for now.
   */
  handleInvalidSequenceNumberData(e) {
    console.log(e);
  }

  /** Modal dialog factory to be used for data deletion confirmation purposes.
   *
   * @param recordTypeName The name of the data type to be displayed in the modal title.
   * @param itemName The name of the specific item to be deleted that will be displayed in the modal body.
   * @param affirmativeCallback The callback function (as void) to be called when the user presses the affirmative context button.
   * @param negativeCallback The callback function (as void) to be called when the user presses the negative context button.
   */
  handleDeleteSubtableRecord(recordTypeName: string,
    itemName: string,
    affirmativeCallback: () => void, negativeCallback: () => void): void {
    const affirmCallbackWrapper = () => {
      try {
        this.modalSvc.setModalWorkingState(true);
        affirmativeCallback();
        this.notiSvc.postNotification(
          this.notiSvc.notificationBuilder(
            `${recordTypeName} Removed`,
            `Successfully removed "${itemName}" from this record.`,
            undefined, undefined, StarbaseNotificationSentiment.Success));
        this.modalSvc.closeModal('user chose yes');
      } catch {
        console.error('Problem attempting to run the affirmative button callback void.');
      }
    };
    const negativeCallbackWrapper = () => {
      try {
        negativeCallback();
        this.modalSvc.closeModal('user chose no');
      } catch {
        console.error('Problem attempting to run the negative button callback void.');
      }
    };
    const affirmBtn = new StarbaseModalButton('Yes, delete it', () => affirmCallbackWrapper());
    const negativeBtn = new StarbaseModalButton('No', () => negativeCallbackWrapper());
    const delModal = new StarbaseModalOptions(
      `Confirm ${recordTypeName} deletion`,
      `Are you sure you want to delete the ${recordTypeName} "${itemName}" from this record?`,
      [affirmBtn, negativeBtn], StarbaseModalTypes.Warning);
    this.modalSvc.postModal(delModal);
  }

  /** Handles removal request for a KeywordLink object.
   * Builds a modal dialog for confirmation before proceeding.
   * If the user confirms, passes control to the Lookup Service.
   *
   * @param keyword The `LU_Keyword` object within the Keyword link for this image to be deleted.
   */
  commitKeywordRemoval(keyword: LU_Keyword): void {
    const yesBtnCb = () => {
      this.keywordSvc.removeKeywordLink(this.imageData.imageKeywords.find(ik => ik.lU_KeywordUID === keyword.uid)).subscribe(() => {

        // display all rows except the removed row
        this.imageData.imageKeywords = this.imageData.imageKeywords.filter(a => a.lU_KeywordUID !== keyword.uid);
        this.setFormDirty();
      }, e => {
        this.notiSvc.postNotification(
          this.notiSvc.notificationBuilder(
            'Deletion failed',
            'Could not unlink the keyword from this record. ' + e['friendly'], undefined, undefined, StarbaseNotificationSentiment.Error));
      });
    };
    const noBtnCb = () => { };
    this.handleDeleteSubtableRecord('Keyword Link', keyword.keyword, yesBtnCb, noBtnCb);
  }

  /** Handles initialization of weapons data by mutating the array received. */
  setupWeaponLinksData(weaponLinks: WeaponLinking[]): WeaponLinking[] {
    if (!weaponLinks) {
 return;
}
    weaponLinks.forEach(w => {
      w.primaryWeapon = w.weapon.primaryWeapon; // initialize so that primaryWeapon has a value
      w.secondaryWeapon = w.weapon.secondaryWeapon; // initialize so that secondaryWeapon has a value
    });
    return weaponLinks;
  }

  /** Handles removal request for a RowModel containing an WeaponLinks object.
   * Builds a modal dialog for confirmation before proceeding.
   * If the user confirms, passes control to the Lookup Service.
   *
   * @param row The IRowModel object describing the WeaponLinks to be deleted.
   */
  commitWeaponLinkRemoval(row: IRowModel): void {
    if (row.uid === 0) {
      return;
    }
    const yesBtnCb = () => {
      this.lookupSvc.deleteData(this.lookupSvc.deleteWeaponLinkUrl, row.uid.toString()).subscribe(() => {
        this.weaponsNotifier.valueChanged(row.uid);
        this.imageData.weapons = this.imageData.weapons.filter(a => a.uid !== row.uid);
      }, e => {
        this.notiSvc.postNotification(
          this.notiSvc.notificationBuilder(
            'Deletion failed',
            'Could not remove the weapon from this record. ' + e['friendly'], undefined, undefined, StarbaseNotificationSentiment.Error));
      });
    };
    const noBtnCb = () => {
      this.imageData.weapons = this.setupWeaponLinksData(this.imageData.weapons);
    };
    this.handleDeleteSubtableRecord('Weapon', row.secondaryWeapon, yesBtnCb, noBtnCb);
  }
  /** Handles initialization of UnitLinking data on the imageData object. */
  setupUnitLinkingData(unitlinks: UnitLinking[]): void {
    UnitLinking.setupUnitLinkCollection(unitlinks);
  }
  setupQMLinkingData(qmLinks: QMManualLink[]): void {
    QMManualLink.setupUnitLinkCollection(qmLinks);
  }


  /** Retrieves the relevant Dates for this record from the server. */
  getDatesData(id: number, page: number): Observable<ImageDate[]> {
    return this.lookupSvc.getAllRequisiteData<ImageDate>(this.lookupSvc.getImageDatesByRecordUrl + id + '&page=' + page).pipe(map(d => {
      if (!this.imageData.relevantDates) {
        this.imageData.relevantDates = [];
      } else if (this.imageData.relevantDates.length && page === 1) {
        this.imageData.relevantDates = []; // clear so we don't duplicate page 1 into displayer
      }
      this.imageData.relevantDates.push(...this.setupDatesData(d));
      return d;
    }));
  }

  /** Retrieves the ImageIndividuals models for this record from the server */
  getIndividualsData(id: number, page: number): Observable<FilterParams<ImageIndividual>> {
    return this.lookupSvc.getRequisiteData<FilterParams<ImageIndividual>>(
      this.lookupSvc.getImageIndividualsByImageUrl + id + '&page=' + page).pipe(map(d => {
      this.setupImageIndividuals(d.collection);
      if (!this.imageData.imageIndividuals) {
        this.imageData.imageIndividuals = [];
      } else if (this.imageData.imageIndividuals.length && page === 1) {
        this.imageData.imageIndividuals = [];
      }
      this.imageData.imageIndividuals.push(...d.collection);
      if (this.IndividualDisplay) {
        this.IndividualDisplay.isUpdateDataRequestSent = false;
      }
      this.totalIndividualRecords = d.totalRecords;
      // eslint-disable-next-line max-len
      this.imageData.imageIndividuals = this.imageData.imageIndividuals.filter(
        (record, index, self) => index === self.findIndex(obj => obj.uid === record.uid));
      return d;
    }),
    catchError(e => {
      if (this.IndividualDisplay) {
        this.IndividualDisplay.isUpdateDataRequestSent = false;
        this.IndividualDisplay.page--;
      }
      return of(new FilterParams<ImageIndividual>());
    }));
  }

  /** Check if all data for UnitLinking object is null.
   *
   * @param unit The UnitLinking (from Unit Picker or formatted) to examine.
   * @returns True if the UnitLinking is valid; false if not. */
  // eslint-disable-next-line max-len
  public unitValidator(unit: {army: UnitArmies; corps: {'corps': number} | number; regiment: Regiment; state: State; branch: BranchOfService; coLetters: string[] }): boolean {
    return !(
      unit.army === null
      && unit.corps === null
      && unit.regiment === null
      && unit.state === null
      && unit.branch === null
      && unit.coLetters);
      // return only if at least one field of unit is defined
    }

    /** Transforms the incoming data to a Unit object,
     *  which is defined as a combination of
     * Regiment, State, BranchOfService, and CompanyLetters (string[]).
     *  Any of those parameters can be null.
     * Checks for duplicates and invalid data before proceeding.
     * Saves the resulting Unit object to the imageData array of UnitLinkings.
     *
     * @param unit The object describing the new Unit.
     */
    // eslint-disable-next-line max-len
    addUnitToData(unit: { army: UnitArmies; corps: number; regiment: Regiment; state: State; branch: BranchOfService; coLetters: string[] }): void {
      if (!this.unitValidator(unit)) { // type check information inputted by the user
      console.error('Got invalid unit data from Unit Picker component.');
      return;
      }
      const ul = new UnitLinking();
      ul.uid = 0;
      ul.army = unit.army;
      ul.corps = unit.corps;
      ul.regimentNo = unit.regiment;
      ul.state = unit.state;
      ul.branch = unit.branch;
      // eslint-disable-next-line eqeqeq
      ul.companyLetters = unit.coLetters.join();
      ul.imageModelId = this.imageData.uid;
      ul.branchId  = ul.branch !== null ? unit.branch.uid : null;
      ul.branchName = ul.branch !== null ? ul.branch.branchName : null;
      ul.stateId = ul.state !== null ? unit.state.uid : null;
      ul.stateName = ul.state !== null ? ul.state.state_Name : null;
      ul.regimentNoId = ul.regimentNo !== null ? unit.regiment.uid : null;
      ul.regimentNumberDisplay = ul.regimentNo !== null ? WriteOrdinalSuffixOfNumber(ul.regimentNo.regimentNo) : null;

      const unitsArr = [...this.imageData.units];
      const arr = unitsArr.map(u => ({
        army: u.army,
        corps: u.corps,
        branchName: u.branchName,
        companyLetters: u.companyLetters ? u.companyLetters : '',
        regimentNumber: u.regimentNoId,
        stateName: u.stateName
      }));
      const row = {
        army: ul.army,
        corps: ul.corps,
        branchName: ul.branchName,
        companyLetters: ul.companyLetters,
        regimentNumber: ul.regimentNoId,
        stateName: ul.stateName
      };
      const bool = checkForDuplicateDataItems(arr, row);
      // eslint-disable-next-line no-console
      console.debug(bool, arr, row);
      if (bool === true) {
        this.imageData.units = unitsArr;
        this.badDataEntered('Could not add duplicate unit.');
      } else if (bool === false) {
        this.imageData.units = unitsArr;
        this.unitsTable.endRow = 5;
        this.unitsTable.rpp = this.imageData.units.length + 1;
        this.unitsTable.updatePaginationData();

        this.imageData.units.unshift(ul);
        this.showUnitBuilder = false;
        this.unitTable.resetFilters();
        this.setFormDirty();
      }
    }

  /** Finds and removes duplicate strings from a string array. To be used with Unit Company Letters.
   *
   * @returns string[] of company letters in upper case.
   */
  findDuplicateCompanyLetters(arr: string[]): string[] {
    const r = [...new Set<string>(arr)];
    r.forEach(a => a.toUpperCase());
    return r;
  }
  /** Removes disallowed company letter input from a string of co letters.
   * Converts the data to upper case and removes spaces.
   *
   * @returns the co letter string data sanitized and converted to an array (splitting at commas).
   */
  sanitizeCompanyLetterInput(col: string): string[] {
    return col.toUpperCase()
      .replace(/[^,ABCDEFGHIKLMNOP]/gi, '')
      .replace(/,\s*$/, '')
      .split(','); // ensure only A-N, not J and commas and no spaces.
  }

  /** Filter the data in columns where the 'dataType' property is "dropdown."
   *
   * @param row The IRowModel instance on which to check all keys.
   * @param cols The array of IColumnModels to check for "dropdown" dataType and then filter data.
   * @param key The optional property name on which the row data should be modified.
   *  If omitted, uses the IColumnModel's dropdownProperty property.
   * @returns The modified row, which is the same as the original row,
   *  but with an object from dropdown data at row[col.dropdownProperty] instead of a string. */
  filterDropdownData(row: IRowModel, cols: IColumnModel[], key?: string): IRowModel { // kmm comment
    // row is the
    cols.forEach(c => {
      if (c.dataType === 'dropdown') {
        c.dropdownData.forEach(obj => {
          if (obj[c.dropdownProperty] === row[c.dropdownProperty]) {
            // if the row should be modified at a location other than row[col.dropdownProperty], should include a key when calling fn
            row[key ? c[key] : c.dropdownProperty] = obj;
          }
        });
      }
    });
    // return the modified row, which is the same as the original row,
    // but with an object from dropdown data at row[col.dropdownProperty] instead of a string
    return row;
  }

  handlePaginationError(e) {
    console.log(e);
  }

  /** Transforms the RowModel data to a UnitLinking object.
   * Stores the resulting UnitLinking object to the imageData.units property.
   *
   * @param row The object describing the altered UnitLink.
   */
  commitUnitLinkChanges(row): void {
    console.log(row);
    // pass in the row to be modified, the columnData for units, and the key (optional). Key defaults to 'dropdownProperty'
    //TODO: ^ Not sure what this accomplishes. There is no 'name' property on UnitLinking.
    row = this.filterDropdownData(row, this.unitLinksColumnData, 'name');
    if (!this.unitValidator(row)) {
      console.error('Got invalid unit data from Table Editor component.');
      return;
    }
    const u = new UnitLinking();
    u.army = row.army && row.army.val ? row.army.val : UnitArmies[row.army] as any;
    u.corps = row.corps.corps;
    u.branch = Object.assign(new BranchOfService(), row.branchName);
    u.branchId = u.branch ? u.branch.uid : null;
    u.imageModelId = row.imageModelId;
    u.regimentNo = Object.assign(new Regiment(), row.regimentNumber);
    u.regimentNoId = u.regimentNo ? u.regimentNo.uid : null;
    u.state = Object.assign(new State(), row.stateName);
    u.stateId = u.state ? u.state.uid : null;
    u.uid = row.uid;
    u.companyLetters = this.findDuplicateCompanyLetters(this.sanitizeCompanyLetterInput(row.companyLetters)).join();
    row.companyLetters = u.companyLetters;
    u.branchName = u.branch !== null ? u.branch.branchName : null;
    u.stateName = u.state ? u.state.state_Name : '';
    u.regimentNumberDisplay = u.regimentNo ? WriteOrdinalSuffixOfNumber(u.regimentNo.regimentNo) : '';
    if (row.uid >= 0) {
      // eslint-disable-next-line @typescript-eslint/no-shadow
      const index = this.imageData.units.findIndex(i => i.uid === row.uid);
      this.imageData.units[index] = u;
    }
    const unitsArr = [...this.imageData.units];
    // eslint-disable-next-line @typescript-eslint/no-shadow
    const i = unitsArr.findIndex(u => u.uid === row.uid);
    unitsArr.splice(i, 1);
    // eslint-disable-next-line @typescript-eslint/no-shadow
    const arr = unitsArr.map(u => ({
      army: u.army,
      corps: u.corps,
      branchName: u.branchName,
      companyLetters: u.companyLetters ? u.companyLetters : '',
      regimentNumber: u.regimentNoId,
      stateName: u.stateName ? u.stateName : ''
    }));
    const r = {
      army: row.army.val,
      corps: row.corps.corps,
      branchName: row.branchName,
      // eslint-disable-next-line eqeqeq
      companyLetters: (row.companyLetters == undefined || row.companyLetters == null) ? '' : row.companyLetters,
      regimentNumber: row.regimentNoId,
      stateName: (row.stateName ? row.stateName.state_Name : '')
    };
    const bool = checkForDuplicateDataItems(arr, r);
    // eslint-disable-next-line no-console
    console.debug(bool, arr, r);
    if (bool === true) {
      // this.imageData.units = unitsArr;
      this.imageData.units.splice(i, 1, row);
      this.badDataEntered('Edit not accepted. Action would create duplicate unit data.');
      return;
    }
    this.imageData.units = [...this.imageData.units];
    this.unitsTable.updatePaginationData();
    this.setFormDirty();
    // this.unitsTable.rpp = 5;
  }

  /** Handles removal request for a UnitLinking object.
   * Builds a modal dialog for confirmation before proceeding.
   * If the user confirms, passes control to the Lookup Service.
   *
   * @param row The UnitLinking object describing the item to be deleted.
   */
  commitUnitLinkRemoval(row: UnitLinking): void { // kmm comment
    if (row.uid === 0) {
      return;
    }
    const yesBtnCb = () => {
      this.lookupSvc.deleteData(this.lookupSvc.deleteUnitLinkUrl, row.uid.toString()).subscribe(() => {
        this.unitsNotifier.valueChanged(row.uid);
        this.imageData.units = this.imageData.units.filter(a => a.uid !== row.uid);
      }, e => {
        this.notiSvc.postNotification(
          this.notiSvc.notificationBuilder(
            'Deletion failed',
            'Could not remove the unit from this record. ' + e['friendly'],
            undefined, undefined, StarbaseNotificationSentiment.Error));
      });
    };
    const noBtnCb = () => {
      this.setupUnitLinkingData(this.imageData.units);
    };
    this.handleDeleteSubtableRecord('Unit', '', yesBtnCb, noBtnCb);
  }

  /** Handles initialization of the Unit data and related data
   * by retrieving the data in order from the Lookup Service and deserializing as needed.
   */
  public setupUnitData(): void {

      Regiment.setupCollection(this.regiments);
      this.regimentColumnData = Regiment.CreateRegimentColumnData(this.statesData);
      this.branchColumnData = BranchOfService.BranchOfServiceColumnData();

  }

  /** Will post an Error type notification to the Notification Service.
   * To be used when the user entered invalid input.
   *
   * @param message Optional. Will display this text in the notification.
   */
  badDataEntered(message = ''): void {
    if (message === '') {
      this.notiSvc.postNotification(
        this.notiSvc.notificationBuilder(
          'Invalid Data',
          'Please enter valid data before saving.',
          undefined, undefined, StarbaseNotificationSentiment.Error));
    } else {
      this.notiSvc.postNotification(
        this.notiSvc.notificationBuilder(
          'Invalid Data',
          message, undefined, undefined, StarbaseNotificationSentiment.Error));
    }
  }

  /** Begins the process of moving the view to the record specified by the ID param.
   *
   * @param id The number identifier of the target record (UID). */
  switchRecord(id: number): void {
    this.galleryTypeSvc.setLastViewedRecordRelatedSetStatus(false);
    this.resetEditBooleans();
    console.log('switching image record');
    this.loaded = false;
    this.gHist.addImageToHistory(this.imageData);
    this.getImageFile(id);
    this.location.pushState(
      this.location.getState(),
      '',
      '/imageSingleView/' + id
    );
  }

  handleCarouselPagination(e) {
    if (e === 'forward') {
      this.imageCarouselLastIndex++;
      this.imageCarouselFirstIndex++;
      this.boundImageCarouselArray = this.imageModels.slice(this.imageCarouselFirstIndex, this.imageCarouselLastIndex);
    } else if (e === 'back') {
      this.imageCarouselLastIndex--;
      this.imageCarouselFirstIndex--;
      this.boundImageCarouselArray = this.imageModels.slice(this.imageCarouselFirstIndex, this.imageCarouselLastIndex);
    } else if (e === 'init') {
      this.imageCarouselFirstIndex = 0;
      this.imageCarouselLastIndex = 3;
      this.boundImageCarouselArray = this.imageModels.slice(this.imageCarouselFirstIndex, this.imageCarouselLastIndex);
    }
  }


  /** Retrieves the image files in the recently viewed history from the Gallery History Service.
   * Sets the result of the observable.
   */
  getHistoryThumbnails(): Observable<ImageFile[]> {
    // this.gHist.imageHistory().subscribe(res => this.historyThumbnailsData = res);
    return this.gHist.imageHistory();
  }

  /** Moves the navigation back to the previous view in browser memory. */
  // goBack(event: any): void { // navigate back to the previous screen (probably gallery)
  //   event.preventDefault();
  //   this.location.back();
  // }

  /** Moves forward in the sequence of images from the gallery service (filter aware) */
  goNextRecord(event: any): void {
    // event.preventDefault();
    this.validateRecordPosition();
    const moveRecord = () => {
      let idx = this.galleryTypeSvc.getFilteredImageIds().findIndex(r => r === this.imageData.uid);
      if (idx === this.galleryTypeSvc.getFilteredImageIds().length - 1) {
        idx = -1;
        } // set to -1 if we are at the end of the list.
      if (idx !== -1) { // next item is in cache
        this.switchRecord(this.galleryTypeSvc.getFilteredImageIds()[++idx]);
      } else { // not in cache, see if we can load more.
        const lastRpp = this.galleryTypeSvc.getLastResultsPerPageSetting(35);
        const cf = this.galleryTypeSvc.getCurrentLibraryFilters(lastRpp);
        // if there is "totalPages" data and we aren't on the last page then load the next page of data and move to that record.
        if (cf.totalPages && cf.totalPages > cf.page) {
          cf.page++;
          this.loaded = false;
          this.getSubscriber = this.imgSvc.getDataByFilterParamsBroadSearch(this.imgSvc.broadSearchUri, cf).subscribe(d => {
            let tempImages = this.galleryTypeSvc.getLibraryImages(lastRpp * cf.page);
            tempImages = [...tempImages, ...d.collection]; // append the data
            this.galleryTypeSvc.setLibraryImages(tempImages);
            this.switchRecord(d.collection[0].uid);
            this.galleryTypeSvc.setCurrentLibraryFilters(cf);
            this.loaded = true;
          });
          this.subscriptionList.push(this.getSubscriber);
          return;
        }
        // otherwise, inform user that we can't navigate because we're at the end of the line for current filters.
        this.notiSvc.postNotification(
          this.notiSvc.notificationBuilder(
            'Could not navigate',
            'There is no next record in memory. Return to the gallery and edit your filters.',
            undefined, 3000, StarbaseNotificationSentiment.Notice));
        console.error('There was no record at that index.');
      }
    };
    this.checkEditModeCanMoveToRecord(moveRecord);
  }
  /** Moves backward in the sequence of images from the gallery service (filter aware) */
  goPrevRecord(event: any): void {
    // event.preventDefault();
    this.validateRecordPosition();
    const moveRecord = () => {
      let idx = this.galleryTypeSvc.getFilteredImageIds().findIndex(r => r === this.imageData.uid);
      if (idx > 0) { // if we aren't at the front of the array already, then move back one.
        this.switchRecord(this.galleryTypeSvc.getFilteredImageIds()[--idx]);
      } else {
        this.notiSvc.postNotification(
          this.notiSvc.notificationBuilder(
            'Could not navigate',
            'There is no previous record in memory. Return to the gallery and edit your filters.',
            undefined, 3000, StarbaseNotificationSentiment.Notice));
        console.error('There was no value at that index.');
      }
    };
    this.checkEditModeCanMoveToRecord(moveRecord);
  }

  private validateRecordPosition(): void {
    // Recalculate fresh values from the source
    const freshTotal = this.calcTotalRecordsInSet();
    const freshRecordNo = this.calcRecordNoInSet();
    
    // Update totalRecordsInSet first
    if (freshTotal > 0) {
      this.totalRecordsInSet = freshTotal;
    }
    
    // Validate and update recordNoInSet
    if (freshRecordNo > 0 && freshRecordNo <= this.totalRecordsInSet) {
      this.recordNoInSet = freshRecordNo;
    } else if (this.totalRecordsInSet > 0) {

      if (this.recordNoInSet > this.totalRecordsInSet) {
        this.recordNoInSet = this.totalRecordsInSet;
      } else if (this.recordNoInSet < 1) {
        this.recordNoInSet = 1;
      }
    } else {
      this.recordNoInSet = 0;
    }
  }

  loadAvailableLedgers() {
    if (!this.imageData?.uid) return;
    
    this.lookupSvc.getExistingRelatedImageSetsForOneImage(this.imageData.uid)
      .subscribe(sets => {
        const ledgers = sets.filter(s => s.setType === 1);
        
        if (ledgers.length >= 1) {
          this.currentLedger = ledgers[0];
          this.isInLedgerMode = true;
          
          // Reset bound set carousel if switching to ledger mode
          if (this.boundImages) {
            this.boundImages.imageModels = [];
          }
          
          // Load ledger data - IMPORTANT: Load images FIRST, then navigation data
          this.loadAllLedgerImages();
        }
        else {
          this.isInLedgerMode = false;
        }
      });
  }

  clearLedgerMode() {
    this.isInLedgerMode = false;
    this.currentLedger = null;
    this.ledgerImages = [];
    this.currentLedgerImageIndex = 0;
    this.currentSequenceNumber = 1;
    this.ledgerImagesPage = 1;
    
    if (this.ledgerCarousel) {
      this.ledgerCarousel.imageModels = [];
    }
  }

  loadAllLedgerImages() {
    if (!this.currentLedger?.uid) return;
    
    this.lookupSvc.getRecordsInSetByNameFromServer(this.currentLedger.uid, 1, true, 1000).subscribe(result => {
      const arr = [];
      result.collection.forEach(item => {
        arr.push(item.imageModel);
      });
      this.ledgerImages = arr;
      
      // NOW load the navigation data after images are loaded
      this.loadLedgerNavigationData();
      
      // Update carousel
      if (this.ledgerCarousel) {
        this.ledgerCarousel.imageModels = this.ledgerImages;
        this.ledgerCarousel.selectedImage = this.imageData;
        this.ledgerCarousel.initializeCarousel();
      }
      
      // Trigger change detection
      this.cd.markForCheck();
    });
  }

  loadMoreLedgerImages() {
    if (!this.loadingMoreLedgerImages && this.currentLedger?.uid) {
      this.loadingMoreLedgerImages = true;
      this.lookupSvc.getRecordsInSetByNameFromServer(this.currentLedger.uid, ++this.ledgerImagesPage, true, 10).subscribe(result => {
        result.collection.forEach(item => {
          this.ledgerImages.push(item.imageModel);
        });
        
        if (this.ledgerCarousel) {
          this.ledgerCarousel.imageModels = this.ledgerImages;
        }
        
        this.loadingMoreLedgerImages = false;
      });
    }
  }

  loadLedgerNavigationData() {
    if (!this.currentLedger?.uid || !this.imageData?.uid) return;
    
    this.isLoadingLedgerData = true;
    this.currentLedgerImageIndex = this.ledgerImages.findIndex(img => img.uid === this.imageData.uid);
    
    if (this.currentLedgerImageIndex !== -1) {
      // Display sequence is just array position + 1 (1-based for display)
      this.currentSequenceNumber = this.currentLedgerImageIndex + 1;
      this.totalLedgerImages = this.ledgerImages.length;
      this.sequenceNumberInput.setValue(this.currentSequenceNumber, {emitEvent: false});
      
      console.log('Ledger navigation loaded:', {
        currentIndex: this.currentLedgerImageIndex,
        displaySequence: this.currentSequenceNumber,
        totalImages: this.totalLedgerImages
      });
    } else {
      console.error('Current image not found in ledger images array');
    }
    
    this.isLoadingLedgerData = false;
    this.cd.markForCheck();
    // this.imgSvc.getLedgerNavigationData(
    //   this.currentLedger.uid,
    //   this.imageData.uid,
    //   this.ledgerWindowSize
    // ).subscribe(
    //   result => {
    //     this.currentSequenceNumber = result.currentSequenceNumber;
    //     this.totalLedgerImages = result.totalCount;
    //     this.sequenceNumberInput.setValue(this.currentSequenceNumber, {emitEvent: false});
    //     this.isLoadingLedgerData = false;
    //   },
    //   error => {
    //     console.error('Error loading ledger data:', error);
    //     this.isLoadingLedgerData = false;
    //     this.isInLedgerMode = false; // Disable ledger mode on error
    //   }
    // );
  }

  navigatePreviousInLedger() {
    if (!this.currentLedger?.uid || this.isLoadingLedgerData) return;
    
    if (this.ledgerCarousel && this.currentLedgerImageIndex > 0) {
      const previousIndex = this.currentLedgerImageIndex - 1;
      const previousImage = this.ledgerImages[previousIndex];
      if (previousImage) {
          this.handleLedgerCarouselSelection(previousImage.uid);
      }
    } else if (this.currentSequenceNumber > 1) {
        this.isLoadingLedgerData = true;
        this.imgSvc.navigateLedgerSequence(this.currentLedger.uid, 'previous', this.currentSequenceNumber).subscribe(
          result => {
            if (result?.image) {
              this.navigateToLedgerImage(result.image, result.sequenceNumber);
            }
            this.isLoadingLedgerData = false;
          },
          error => {
            console.error('Error navigating to previous:', error);
            this.isLoadingLedgerData = false;
          }
        );
      }
  }

  private navigateToLedgerImage(image: ImageFile, sequenceNumber: number) {
    // Save current ledger state
    const savedLedger = this.currentLedger;
    const savedMode = this.isInLedgerMode;
    const savedImages = this.ledgerImages;
    const savedIndex = sequenceNumber - 1;
    
    // Load the new image
    this.getImageFile(image.uid);
    
    // Restore ledger state after navigation
    setTimeout(() => {
      this.currentLedger = savedLedger;
      this.isInLedgerMode = savedMode;
      this.ledgerImages = savedImages;
      this.currentSequenceNumber = sequenceNumber;
      this.currentLedgerImageIndex = savedIndex;
      this.sequenceNumberInput.setValue(this.currentSequenceNumber, {emitEvent: false});
      
      // Update ledger carousel selection and center it
      if (this.ledgerCarousel) {
        this.ledgerCarousel.selectedImage = image;
        this.ledgerCarousel.currentSelectedImageIndex = savedIndex;
        this.ledgerCarousel.initializeCarousel(); // Re-center after navigation
      }
    }, 100);
  }

  navigateNextInLedger() {
    if (!this.currentLedger?.uid || this.isLoadingLedgerData) return;
    
    // Check if we can navigate to next image in the loaded carousel
    if (this.ledgerCarousel && this.currentLedgerImageIndex < this.ledgerImages.length - 1) {
      const nextIndex = this.currentLedgerImageIndex + 1;
      const nextImage = this.ledgerImages[nextIndex];
      
      if (nextImage) {
        this.handleLedgerCarouselSelection(nextImage.uid);
      }
    // } else if (this.currentSequenceNumber < this.totalLedgerImages) {
    //   this.isLoadingLedgerData = true;
    //   this.imgSvc.navigateLedgerSequence(
    //     this.currentLedger.uid, 
    //     'next', 
    //     this.currentSequenceNumber
    //   ).subscribe(
    //     result => {
    //       if (result?.image) {
    //         this.navigateToLedgerImage(result.image, result.sequenceNumber);
    //       }
    //       this.isLoadingLedgerData = false;
    //     },
    //     error => {
    //       console.error('Error navigating to next:', error);
    //       this.isLoadingLedgerData = false;
    //     }
    //   );
    // }
    }
  }

  handleLedgerCarouselSelection(imageUID: number) {
    if (this.isInLedgerMode && this.ledgerImages.length > 0) {
      const selectedImage = this.ledgerImages.find(img => img.uid === imageUID);
      if (selectedImage) {
        const arrayIndex = this.ledgerImages.findIndex(img => img.uid === imageUID);
        const displaySequence = arrayIndex + 1; // Convert to 1-based display
        
        // Update sequence tracking
        this.currentLedgerImageIndex = arrayIndex;
        this.currentSequenceNumber = displaySequence;
        this.sequenceNumberInput.setValue(displaySequence, {emitEvent: false});
        
        // Update carousel selection and center it
        if (this.ledgerCarousel) {
          this.ledgerCarousel.selectedImage = selectedImage;
          this.ledgerCarousel.currentSelectedImageIndex = arrayIndex;
          this.ledgerCarousel.initializeCarousel();
        }
        
        // Navigate to the selected image
        this.navigateToLedgerImage(selectedImage, displaySequence);
      }
    }
  }

  jumpToSequence(sequenceNumber: number) {
    if (!this.currentLedger?.uid || this.isLoadingLedgerData) return;
    if (sequenceNumber === this.currentSequenceNumber) return;
    if (sequenceNumber < 1 || sequenceNumber > this.totalLedgerImages) return;
    
    this.currentSequenceNumber = sequenceNumber;
    this.loadLedgerNavigationData();
  }


  exitLedgerMode() {
    this.isInLedgerMode = false;
    this.currentLedger = null;
    this.currentSequenceNumber = 1;
    this.totalLedgerImages = 0;
  }

  loadImageData(id: number, navigation?: string) {
    if (!navigation || navigation !== 'ledger') {
      this.loadAvailableLedgers();
    }
  }


  /** Handles toggling the checkbox for Portrait_Field.
   *
   * @param val The string representation of the state of the checkbox for this field.
   */
  togglePortrait(val: string): void {
    if (this.imageData.portrait_Field === null) {
      this.imageData.portrait_Field = val;
      return;
    }
    if (this.imageData.portrait_Field === 'portrait') {
      this.imageData.portrait_Field = 'field';
    } else {
      this.imageData.portrait_Field = 'portrait';
    }
  }

  /** Marks the edit mode form as "dirty," which enables the Save button and changes the Cancel button to act as a revert button. */
  setFormDirty(): void {
    this.imageForm.control.markAsTouched();
    this.imageForm.control.markAsDirty();
  }

  /** Handles changes to the checked Out checkbox field. */c
  markCheckOutStatusChanged(): void {
    this.checkOutStatusChanged = true;
  }

  /* .... RTF-related section .... */
  /** Called when edits are made on the RTF component to trigger the edit mode form as "dirty."" */
  handleRTFChanges(ev: ActionCompleteEventArgs) {
    this.setFormDirty();
    console.log("ev: ", ev, ev?.requestType);
    if (ev?.requestType === 'Maximize') {
      this.setFullscreenRTF(true);
    }

    if (ev?.requestType === 'Minimize') {
      this.setFullscreenRTF(false);
    }
  }
  /** Check actions emitted from RTF component to see if scroll ocurred. */
  handleRTFActions(event) {
    // eslint-disable-next-line curly
    if (isDevMode()) {
      // eslint-disable-next-line no-console
      console.debug(event);
    }
  }

  // placeholder for function to place custom hidden anchor code in RTF field
  insertRTFAnchor() {
    if (!this.imageModels || !this.imageModels.length) {
      this.notiSvc.postNotification(this.notiSvc.notificationBuilder(
        'No can do',
        `Anchors are only available for Bound Sets.
         This image does not belong to a Bound Set.
         You can create Bound Sets from the gallery screen.`,
        undefined, 6750, StarbaseNotificationSentiment.Error
      ));
      return;
    }
    const selection: NodeSelection = new NodeSelection();
    const ranges: Range = selection.getRange(document);
    // Get the UID of the bound image currently being viewed (by matching name)
    const u = this.imageModels.find(a => a.name === this.displayName);
    // Create a line break with dashes and inside of it, an invisible <a> anchor whose ID is "rtfAnchor_{UID of Image}"
    const toInsertLink = document.createTextNode(
      `&lt;a id="rtfAnchor_${u.uid}" class="anchorLink" &gt;----------${this.displayName}----------&lt;/a&gt;`);
    ranges.insertNode(toInsertLink);
  }

  /** Can be called by the RTF Component, if present, when it is created.
   * For the purposes of setting up custom controls and functionality on RTF editor component.
   */
  rtfCreated() {
    const customAnchorBtn = document.getElementById('custom_anchor_tbar') as HTMLElement;

    customAnchorBtn.onclick = () => {
      this.insertRTFAnchor(); // adds binding to click event at init
    };
  }
  /* .... End RTF-related section .... */


  /** Called by Save button.
   * This function performs the preprocessing needed for the Save to server action
   * (done in ImageService) for all data and sub-table data linked on this record.
   *  It also moves the editMode to false when done. It handles reporting errors during the save operation.
   * First checks if any Table-Editor instances were left "unfinished" and belays save action if any were.
   * Handles Checked-out status record changes.
   *
   * @param callback Optional. Defaults to null.
   *  If used, if the Image Service successfully saves the data, this callback will be triggered. */
  submitChanges(callback: () => void = null): void {
    try {
      const i = this.tableEditors.some(
        t => {
          if (t.editMode) {
            this.notiSvc.postNotification(
              this.notiSvc.notificationBuilder(
                'Incomplete data entry',
                'Please finish your changes on ' + t.tableTitle + ' before saving.',
                undefined, 2500, StarbaseNotificationSentiment.Warning));
            return true;
            // eslint-disable-next-line curly
          } else return false;
        }
      );
      if (i) {
 console.warn('Some table editors were left unsaved.'); return;
}
    } catch (e) {
      console.error(e);
    }
    let c: string = null;
    this.saveInProgress = true;
    try {
      if (this.checkOutStatusChanged) {
        c = (this.imageData.checkedOut) ? 'CheckedOut' : 'CheckedIn';
      }
      // fix empty days in dates before copying or sending to server
      if (this.imageData.relevantDates) {
        this.imageData.relevantDates.forEach(d => {
          d.day = !d.day ? 0 : d.day;
          d.year = !d.year ? 0 : d.year;
          d.month = !d.month ? 0 : d.month;
          d.quarter = !d.quarter ? 0 : d.quarter;
        });
      }
      const recordToSave: ImageFile = JSON.parse(JSON.stringify(this.imageData));
      /* eslint-disable curly */
      if (recordToSave.imageIndividuals) {
        recordToSave.imageIndividuals.forEach(r => {
          if (r.rank) r.rank = null;
          if (r.state) r.state = null;
          if (r.regimentNo) r.regimentNo = null;
          if (r.branch) r.branch = null;
        });
      } else {
        recordToSave.imageIndividuals = [];
      }
      if (recordToSave.imageKeywords) {
        recordToSave.imageKeywords = [];
      }
      if (recordToSave.weapons)
        recordToSave.weapons.forEach(w => {
 w.primaryWeapon = null; w.weapon = null;
});
      if (recordToSave.units)
        recordToSave.units.forEach(u => {
          u.state = null;
          u.regimentNo = null;
          u.branch = null;
        });

      if (recordToSave.quarterMasterManuals) {
        recordToSave.quarterMasterManuals.forEach(obj => {
          obj.qM_ManualModel = null;
        });
      }
      if (recordToSave.sourceCallNumber) recordToSave.sourceCallNumber.lU_Source = null;
      recordToSave.source = null;
      this.updateSubscriber = this.imgSvc.updateImageDataOnServer(recordToSave, c).subscribe(() => {
        console.log('Saved successfully.');
        this.notiSvc.postNotification(
          this.notiSvc.notificationBuilder(
            'Saved successfully',
            'Your changes were saved to the server.',
            undefined, undefined, StarbaseNotificationSentiment.Success));
        this.imageForm.control.markAsPristine();
        this.lookupSvc.clearImageIndividualsCache();
        // eslint-disable-next-line curly
        if (!this.stayInEditMode)
          this.editMode = false;
        this.getImageFile(this.imageData.uid);
        this.checkOutStatusChanged = false;
        if (this.imageData.orderNo) {
          this.galleryTypeSvc.clearLibraryImages();
        } else {
          this.galleryTypeSvc.updateLibraryImage(this.imageData);
        }

        this.getWeapons(); // refresh weapon LU data
        // TODO: Can this be moved to the deserialize for WeaponLink and just construct/deserialize here?
        this.imageData.weapons.forEach(obj => {
          if (obj.uid !== 0) {
            obj.weapon_Category = obj.weapon.primaryWeapon.weapon_Category;
          }
        });

        if (callback) {
          callback(); // callback func only runs if the data saves successfully.
        }
      },
        err => {
          console.error('Save failed:'); console.error(err);
          let e = typeof (err) === 'string' ? err : err['friendly'];
          if (this.loginSvc.getUserModel().isAdmin()) {
            e = typeof (err) === 'string' ? err : (err['error'] || err['serverMsg'][0]);
          }
          this.notiSvc.postNotification(
            this.notiSvc.notificationBuilder(
              'Error when saving',
              e, undefined, undefined, StarbaseNotificationSentiment.Error));
          this.saveInProgress = false;
        },
        () => {
          this.saveInProgress = false;
          this.imgSvc.clearFilterCache(); // force update of filter data from server to accommodate changes here
        });
      this.subscriptionList.push(this.updateSubscriber);
    } catch (e) {
      console.error('Save failed. ' + e);
      this.notiSvc.postNotification(
        this.notiSvc.notificationBuilder(
          'Error when saving',
          e, undefined, undefined, StarbaseNotificationSentiment.Error));
      this.saveInProgress = false;
    }

  }

  /** Called by the Cancel button if the form is "dirty."
   * Undoes all changes by calling getImageFile for the current record,
   * which reloads the data from the Image Service. Marks the form as "pristine"
   * and calls a reset function for all edit flags.
   */
  cancelChanges(): void {
    this.setFullscreenRTF(false);
    this.notiSvc.postNotification(
      this.notiSvc.notificationBuilder(
        'Canceling your changes',
        'Reloading...', undefined, undefined, StarbaseNotificationSentiment.Info));
    this.imageForm.control.markAsPristine();
    this.resetEditBooleans();
    this.getImageFile(this.imageData.uid);
    this.singleImageViewWrapper?.nativeElement.focus();

    if (this.imageData.quarterMasterManuals && this.imageData.quarterMasterManuals.length > 0) {
        for (let i = this.imageData.quarterMasterManuals.length - 1; i >= 0; i--) {
          if (this.imageData.quarterMasterManuals[i]['added_before_save']) {
            this.imageData.quarterMasterManuals.splice(i, 1);
          }
        }
    }
  }

  applySearchHighlight(): void {
    const pipe = new EmboldenPipe(this.sanitizer);
    this.imageData.transcription = pipe.transform(
      this.imageData.transcription,
      this.librarySearchText,
      0,
      this.searchHighlightStyle).toString();
  }

  openSuggestContent(): void {
    if (!this.appComponent.contactUsModalOpen) {
      this.appGlobalsSvc.openContactRequest(CONTACTUS_SUGGESTION, { uid: this.imageData.uid, name: this.imageData.name });
    }
  }

  /** Resets the newEntityMode for each table-editor and editMode for each row in the table-editors.
   * Resets all edit mode flag booleans.
   * Resets all toggle-able component flags.
   * Exits edit mode if stayInEditMode is off.
   */
  private resetEditBooleans(): void {
    this.tableEditors.forEach(t => {
      t.newEntityMode = false;
      t.tableData.forEach(d => d.editMode = false);
    });
    if (!this.stayInEditMode) {
      this.editMode = false;
    }
    this.newArmyMode = false;
    this.newUnitMode = false;
    this.newWeaponMode = false;
    this.newRegimentMode = false;
    this.newBranchMode = false;
    this.newWeaponCatMode = false;
    this.newRankMode = false;
    this.newSourceMode = false;
    this.showIndividualEditor = false;
    this.showUnitBuilder = false;
    this.individualData = null;
  }


  /** Retrieves the UnitLinking Models for this record from the server */
  private getUnitLinkingData(id: number): Observable<UnitLinking[]> {
    return this.lookupSvc.getAllRequisiteData<UnitLinking>(this.lookupSvc.getUnitLinksUrl + id).pipe(map(d => {
      this.setupUnitLinkingData(d);
      this.imageData.units = d;
      return d;
    }));
  }
  /** Retrieves the Quartermaster Specifications for this record from the server. */
  private getQM_SpecLinkingData(id: number): Observable<QMManualLink[]> {
    return this.lookupSvc.getAllRequisiteData<QMManualLink>(this.lookupSvc.getQMLinksUrl + id).pipe(
      map(d => {
        this.setupQMLinkingData(d);
        this.imageData.quarterMasterManuals = d;
        return d;
      })
    );
  }

  /** Handles the error condition of standard Typeahead lookup calls.
   *
   * @param name The name of the typeahead function that is calling this method.
   */
   private typeaheadFailure(err: Error, name?: string): Observable<any[]> {
    console.error((name || 'A') + ' lookup failed. The typeahead service ran into a problem.');
    this.appInsights.logError(err, { 'typeahead error': name });
     // this.notiSvc.postNotification(
     // this.notiSvc.notificationBuilder(name + ' lookup failed',
     // 'The typeahead service ran into a problem.', StarbaseNotificationTypes.Error));
    return of([]);
   }
   private processDisplayName(img: ImageFile): string {
    return img.name;
  }

   /** Handles the loading of the image from the Image Service and subsequent loading of related data for that image file. Handles errors.
    *
    * @param optId Optional. Defaults to the current route's ID if omitted. Used to identify the image record to load by its UID. */
  private getImageFile(optId?: number): void {
    const id = (optId) ? optId : +this.route.snapshot.paramMap.get('id');
    const strId = id.toString();
    const qmID = (optId) ? null : +this.route.snapshot.paramMap.get('qmid');
    if (qmID !== null && qmID !== 0) {
      this.loadedFromQM = true; this.simpleIndex = true;
      this.qmID = qmID;
    }
    this.imgSvc.forceStaleData();
    this.getSubscriber = this.imgSvc.getData(this.imgSvc.getOneUri, strId).subscribe(d => {
      try {
        this.imageData = d;
        this.displayName = this.processDisplayName(this.imageData);
        // eslint-disable-next-line max-len
        this.datesColumnData = (this.imageData.typeOfImageId === ImageTypes.Ordnance_Returns) ? ImageDate.imageDateWithQuarterColumnData(MONTHS) : ImageDate.imageDateColumnData(MONTHS); // if this image type is Ordnance Return, then show the Quarter column
        this.unitData$ = this.getUnitLinkingData(id);
        this.weaponsData$ = this.getWeaponLinkingData(id);
        this.individualsData$ = this.getIndividualsData(id, 1);
        this.qmsData$ = this.getQM_SpecLinkingData(id);
        this.datesData$ = this.getDatesData(id, 1);
        this.datesData$.subscribe();

        this.getRecordSets(id);
        this.getRelatedImageSetData(id);
        this.loadAvailableLedgers();
        this.galleryTypeSvc.setLastSelectedRecord(this.imageData); // for the thumbnail blue highlight on the gallery screen
        this.boundImageSetsCols = BoundImageSet.boundImageSetColumnData();
        this.boundImageSetRows = [];
        if (d.boundSetName) { // if this record is the cover of a bound set
          this.getBoundImageSetForThisImage();
        } else {
          this.clearBoundImageSetForThisImage();
        }
        this.imageData.filePath = this.correctedFilepath(this.imageData);
        if (this.imageData.army) {
          this.imageData.army = new Army().deserialize(this.imageData.army);
        }
        if (this.imageData.sourceCallNumber) {
          this.imageData.sourceCallNumber = new CallNumberModel().deserialize(this.imageData.sourceCallNumber);
        }
        // check for valid URL in Call # data. Will create hyperlink in the template if it is.
        this.callNoIsUrl = this.isStringUrl(this.imageData.callNo);
        if (this.librarySearchText && this.imageData.transcription && this.imageData.transcription !== '') {
          this.originalTranscriptionText = this.imageData.transcription;
          const pipe = new EmboldenPipe(this.sanitizer);
          this.imageData.transcription = pipe.transform(
            this.imageData.transcription,
            this.librarySearchText,
            0,
            this.searchHighlightStyle)
            .toString().
            replace('SafeValue must use [property]=binding:', '')
            .replace('(see http://g.co/ng/security#xss)', '');
            /* HACK: Hacky, but I don't have a good way around this when using the ejs RTF control.
            * This needs to be checked on each Angular framework upgrade too because the phrasing might change. */
          // TODO: Make a unit test for the above note
        }
        this.recordNoInSet = this.calcRecordNoInSet(); 
        this.totalRecordsInSet = this.calcTotalRecordsInSet();
        this.titleSvc.setTitle('Research Arsenal: ' + this.displayName);
        this.loaded = true;
        setTimeout(() => {
          this.connectAnchorLinks();
        }, 500);
        this.loadAvailableLedgers();
      } catch (e) {
      console.log(e);

        this.handleLoadingError(e);
       }
    },
    err => this.handleLoadingError(err));
    this.subscriptionList.push(this.getSubscriber);
  }

  private handleLoadingError(err: Error | string) {
    const e = typeof (err) === 'string' ? err : err['friendly'];
    this.notiSvc.postNotification(this.notiSvc.notificationBuilder('Error', e, undefined, undefined, StarbaseNotificationSentiment.Error));
    this.errorMessage = 'Sorry, we could not load the record at this time. ';
    console.error(e);
  }
   /** Retrieves the WeaponLinking Models for this record from the server */
   private getWeaponLinkingData(id: number): Observable<WeaponLinking[]> {
    return this.lookupSvc.getAllRequisiteData<WeaponLinking>(this.lookupSvc.getWeaponLinksUrl + id).pipe(map(d => {
      this.imageData.weapons = this.setupWeaponLinksData(d);
      return d;
    }));
   }
   private calcRecordNoInSet(): number {
    const filteredIds = this.galleryTypeSvc.getFilteredImageIds();

    if (!this.imageData || !this.imageData.uid) {
      return 1;
    }
    
    const indexInCache = filteredIds.findIndex(i => i === this.imageData.uid);
    if (indexInCache === -1) {
      // Image not found in current cache - return 1 as fallback
      return 1;
    }
    // indexInCache is 0-based, add 1 for 1-based display
    return indexInCache + 1;
  }

  private dataLookupCallsArray(): Observable<any>[] {
    return [
      this.lookupSvc.getAllRequisiteData<Army>(this.lookupSvc.getArmiesUrl).pipe(tap(armies => this.setupArmies(armies))),
      this.lookupSvc.getAllRequisiteData<LUArmy>(this.lookupSvc.getLUArmiesUrl).pipe(tap(luArmies => this.setupLUArmies(luArmies))),
      this.lookupSvc.getAllRequisiteData<State>(this.lookupSvc.getStatesUrl).pipe(tap(s => this.setupStates(s))),
      this.lookupSvc.getAllRequisiteData<Rank>(this.lookupSvc.getRanksUrl).pipe(map(ranks => this.setupRanks(ranks))),
      this.lookupSvc.getAllRequisiteData<RankCategory>(this.lookupSvc.getRankCatsUrl).pipe(map(rankCats => this.setupRankCats(rankCats))),
      this.lookupSvc.getAllRequisiteData<LUSource>(this.lookupSvc.getLUSourcesUrl).pipe(map(sources => this.setupSources(sources))),
      this.lookupSvc.getAllRequisiteData<Battle>(this.lookupSvc.getBattlesUrl).pipe(map(battles => this.setupBattles(battles)))
    ];
  }

  private calcTotalRecordsInSet(): number {
    if (this.simpleIndex) {
      // For simple index mode
      return this.galleryTypeSvc.getFilteredImageIds().length;
    }
    const currentFilters = this.galleryTypeSvc.getCurrentLibraryFilters();
    // Use totalRecords from the filter params if available (this is the server's total count)
    if (currentFilters && currentFilters.totalRecords && currentFilters.totalRecords > 0) {
      return currentFilters.totalRecords;
    }
    // Fallback to cached array length
    return this.galleryTypeSvc.getFilteredImageIds().length;
  }

  private correctedFilepath(i: ImageFile = this.imageData): string {
    if (isDevMode() && false) { // alter the file path to load from web API server Windows FS instead of web app server if in dev mode. Otherwise intended to load from Azure FS
      const path =
        (i.filePath.includes(WebApiService.GetAPIServerAddress())) ? i.filePath : WebApiService.GetAPIServerAddress() + '/' + i.filePath;
      return path.replace('wwwroot/', '');
    } else {
      return i.filePath + '&' + Date.now(); // HACK: Azure FileStorage cache workaround
    }
  }
  /** Handles moving away from the route when, taking into account editMode status and
   * stayInEditMode status. Takes appropriate action once evaluated.
   * If stayInEditMode and EditMode are both on, the callback function wil be triggered.
   * Otherwise, runs the editCheck() method to continue.
   *
   * @param callback Optional. Defaults to empty void.
   *  Will be called when editMode and stayInEditMode are true (use to perform the actual move to a new record or route).
   */
   private checkEditModeCanMoveToRecord(callback?: () => any): void {
    if (this.editMode && this.stayInEditMode) {
      this.submitChanges(callback());
    } else {
      this.unsavedChangesCheck().subscribe(a => {
        if (a) {
          callback();
        } else {
          return false;
        }
      });
    }
  }
}
